export default [
  {
    "name": "get:/access_control/api/v1/access_point/{id}",
    "title": "Метод получения точки доступа по идентификатору",
    "method": "get",
    "service": "access_control",
    "module": "access_point",
    "resource": "access_point",
    "access": "card",
    "scope": "access_control:access_point:card",
    "description": "Метод доступен для: admin, service, bti.Метод доступен для: ApiKey",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_control/api/v1/access_point/{accessPointGroup.accessPointId}/group/{accessPointGroup.groupId}/attach",
    "title": "Метод создания связи точки доступа и группы",
    "method": "put",
    "service": "access_control",
    "module": "access_point",
    "resource": "group",
    "access": "edit",
    "scope": "access_control:access_point:group:edit",
    "description": "Метод доступен для: admin, service, bti",
    "params": [
      "accessPointGroup.accessPointId",
      "accessPointGroup.groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_control/api/v1/access_point/{accessPointGroup.accessPointId}/group/{accessPointGroup.groupId}/detach",
    "title": "Метод удаления связи точки доступа и группы",
    "method": "put",
    "service": "access_control",
    "module": "access_point",
    "resource": "group",
    "access": "edit",
    "scope": "access_control:access_point:group:edit",
    "description": "Метод доступен для: admin, service, bti",
    "params": [
      "accessPointGroup.accessPointId",
      "accessPointGroup.groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/access_point/group/count",
    "title": "Метод получения количества связей точек доступа и групп",
    "method": "get",
    "service": "access_control",
    "module": "access_point",
    "resource": "group",
    "access": "list",
    "scope": "access_control:access_point:group:list",
    "description": "Метод доступен для: admin, service, bti",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/access_point/group/list",
    "title": "Метод получения списка связей точек доступа и групп",
    "method": "get",
    "service": "access_control",
    "module": "access_point",
    "resource": "group",
    "access": "list",
    "scope": "access_control:access_point:group:list",
    "description": "Метод доступен для: admin, service, bti",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/access_point/count",
    "title": "Метод получения количества точек доступа",
    "method": "get",
    "service": "access_control",
    "module": "access_point",
    "resource": "access_point",
    "access": "list",
    "scope": "access_control:access_point:list",
    "description": "Метод доступен для: admin, service, bti.Метод доступен для: ApiKey",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/access_point/list",
    "title": "Метод получения списка точек доступа",
    "method": "get",
    "service": "access_control",
    "module": "access_point",
    "resource": "access_point",
    "access": "list",
    "scope": "access_control:access_point:list",
    "description": "Метод доступен для: admin, service, bti.Метод доступен для: ApiKey",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/access_control/api/v1/access_point/open",
    "title": "Метод открытия точки доступа",
    "method": "post",
    "service": "access_control",
    "module": "access_point",
    "resource": "open",
    "access": "save",
    "scope": "access_control:access_point:open:save",
    "description": "Метод доступен для: admin, service, bti.Метод доступен для: ApiKey",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/access_control/api/v1/access_point/{id}",
    "title": "Метод удаления точки доступа",
    "method": "delete",
    "service": "access_control",
    "module": "access_point",
    "resource": "access_point",
    "access": "remove",
    "scope": "access_control:access_point:remove",
    "description": "Метод доступен для: admin, service, bti",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/access_control/api/v1/access_point",
    "title": "Метод сохранения точки доступа",
    "method": "post",
    "service": "access_control",
    "module": "access_point",
    "resource": "access_point",
    "access": "save",
    "scope": "access_control:access_point:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: admin, service, bti",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/access_control/internal/api/v1/broadcast_alert/start",
    "title": "Метод запуска массового оповещения через домофоны",
    "method": "post",
    "service": "access_control",
    "module": "broadcast_alert",
    "resource": "start",
    "access": "save",
    "scope": "access_control:broadcast_alert:start:save",
    "description": "Метод доступен для: ApiKey",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "post:/access_control/internal/api/v1/broadcast_alert/stop",
    "title": "Метод прекращения массового оповещения через домофоны",
    "method": "post",
    "service": "access_control",
    "module": "broadcast_alert",
    "resource": "stop",
    "access": "save",
    "scope": "access_control:broadcast_alert:stop:save",
    "description": "Метод доступен для: ApiKey",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/building/{id}",
    "title": "Метод получения Дома",
    "method": "get",
    "service": "access_control",
    "module": "building",
    "resource": "building",
    "access": "card",
    "scope": "access_control:building:card",
    "description": "Для пользователей типов owner, employee: в результат попадают только дома, которые привязаны к компании пользователя или дома квартирограамм привязанных к компании пользователя.Метод доступен для: admin, service, owner, employee, seller, external_seller, ltp_first, bti",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/building/orpon/{orpon}/exists",
    "title": "Метод проверки существования дома по ОРПОН",
    "method": "get",
    "service": "access_control",
    "module": "building",
    "resource": "exists",
    "access": "list",
    "scope": "access_control:building:exists:list",
    "description": "Возвращает true если найден дом с указанным ОРПОН.Метод доступен для: admin, service",
    "params": [
      "orpon"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/building/count",
    "title": "Метод получения количества домов",
    "method": "get",
    "service": "access_control",
    "module": "building",
    "resource": "building",
    "access": "list",
    "scope": "access_control:building:list",
    "description": "Для пользователей типов owner, employee: в результат попадают только дома, которые привязаны к компании пользователя или дома квартирограамм привязанных к компании пользователя.Метод доступен для: admin, service, owner, employee, ltp_first, bti",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/building/list",
    "title": "Метод получения списка домов",
    "method": "get",
    "service": "access_control",
    "module": "building",
    "resource": "building",
    "access": "list",
    "scope": "access_control:building:list",
    "description": "Для пользователей типов owner, employee: в результат попадают только дома, которые привязаны к компании пользователя или дома квартирограамм привязанных к компании пользователя.При запросе через ApiKey происходит дополнительная фильтрация домов на основе доступности домов для этого ApiKey (фильтрация происходит по доступным AccessPoint для этой группы).Метод доступен для: admin, service, owner, employee, ltp_first, bti.Метод доступен для: ApiKey",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/building/orpon/{orpon}/subscription_mode",
    "title": "Метод получения статуса режима работы с подписками у помещений дома",
    "method": "get",
    "service": "access_control",
    "module": "building",
    "resource": "subscription_mode",
    "access": "list",
    "scope": "access_control:building:subscription_mode:list",
    "description": "Возвращает агрегированный статус по всем помещениям дома.Метод доступен для: admin, service, ltp_first, bti",
    "params": [
      "orpon"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_control/api/v1/entrance/{entranceDevice.orpon}/{entranceDevice.entranceNumber}/device/{entranceDevice.deviceId}/attach",
    "title": "Метод создания связи подъезда и устройства",
    "method": "put",
    "service": "access_control",
    "module": "entrance",
    "resource": "device",
    "access": "edit",
    "scope": "access_control:entrance:device:edit",
    "description": "Для ролей employee, owner можно сохранять только связи с подъездами квартирограмм, привязанным к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).EntranceDevice.RelationType в данном методе не используется.Метод доступен для: admin, service, owner, employee",
    "params": [
      "entranceDevice.orpon",
      "entranceDevice.entranceNumber",
      "entranceDevice.deviceId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_control/api/v1/entrance/{entranceDevice.orpon}/{entranceDevice.entranceNumber}/device/{entranceDevice.deviceId}/detach",
    "title": "Метод удаления связи подъезда и устройства",
    "method": "put",
    "service": "access_control",
    "module": "entrance",
    "resource": "device",
    "access": "edit",
    "scope": "access_control:entrance:device:edit",
    "description": "Для ролей employee, owner можно удалять только связи с подъездами квартирограмм, привязанным к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).EntranceDevice.RelationType в данном методе не используется.Метод доступен для: admin, service, owner, employee",
    "params": [
      "entranceDevice.orpon",
      "entranceDevice.entranceNumber",
      "entranceDevice.deviceId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/entrance/device/list",
    "title": "Метод получения списка связок подъезд-устройство",
    "method": "get",
    "service": "access_control",
    "module": "entrance",
    "resource": "device",
    "access": "list",
    "scope": "access_control:entrance:device:list",
    "description": "Для ролей employee, owner можно получать только связи с подъездами квартирограмм, привязанным к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).Метод доступен для: admin, service, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/entrance/list",
    "title": "Метод получения списка подъездов",
    "method": "get",
    "service": "access_control",
    "module": "entrance",
    "resource": "entrance",
    "access": "list",
    "scope": "access_control:entrance:list",
    "description": "При переданном company_ids учитывается тип связи компании и квартирограммы.Если EntranceFilter.CompanyRelationType = DEVICE_SERVICE, то проверяется связка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE.Если EntranceFilter.CompanyRelationType = MANAGEMENT, то проверяется связка в flatgramm_companies.Если EntranceFilter.CompanyRelationType = DEFAULT, то проверяется связка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE.Если EntranceFilter.CompanyRelationType = COMPANY_RELATION_TYPE_UNKNOWN, вернется ошибка валидации.При не переданном company_ids поле EntranceFilter.CompanyRelationType вызовет ошибку валидации.Для ролей employee, owner можно получать только подъезды квартирограмм, привязанные к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).Метод доступен для: admin, service, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/access_control/api/v1/entrance/{orpon}/{entranceNumber}",
    "title": "Метод удаления подъезда",
    "method": "delete",
    "service": "access_control",
    "module": "entrance",
    "resource": "entrance",
    "access": "remove",
    "scope": "access_control:entrance:remove",
    "description": "Реализуется как удаление квартир по указанному дому и номеру подъезда.Для ролей employee, owner можно удалять только подъезды квартирограмм, привязанные к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).Метод доступен для: admin, service, owner, employee",
    "params": [
      "orpon",
      "entranceNumber"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/access_control/api/v1/entrance",
    "title": "Метод создания подъезда",
    "method": "post",
    "service": "access_control",
    "module": "entrance",
    "resource": "entrance",
    "access": "save",
    "scope": "access_control:entrance:save",
    "description": "Для ролей employee, owner можно сохранять только подъезды квартирограмм, привязанные к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).Метод доступен для: admin, service, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/flatgramm/{id}",
    "title": "Метод получения облегченной квартирограммы",
    "method": "get",
    "service": "access_control",
    "module": "flatgramm",
    "resource": "flatgramm",
    "access": "card",
    "scope": "access_control:flatgramm:card",
    "description": "Для пользователей типов owner, employee возвращаются только квартирограммы привязанные к компании пользователя.Для пользователей типов owner, employee: в результат попадают только квартирограммы, привязанные к компании пользователя по любому из типов связи FlatgrammCompanyRelation.Type.Метод доступен для: admin, manager, service, bti, ltp_first, owner, employee",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_control/api/v1/flatgramm/{flatgrammCompanyRelation.flatgrammId}/company_relation/{flatgrammCompanyRelation.companyId}/attach",
    "title": "Метод сохранения связей квартирограммы и компании",
    "method": "put",
    "service": "access_control",
    "module": "flatgramm",
    "resource": "company_relation",
    "access": "edit",
    "scope": "access_control:flatgramm:company_relation:edit",
    "description": "Поддерживает только создание.Метод доступен для: admin, service, seller",
    "params": [
      "flatgrammCompanyRelation.flatgrammId",
      "flatgrammCompanyRelation.companyId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_control/api/v1/flatgramm/{flatgrammCompanyRelation.flatgrammId}/company_relation/{flatgrammCompanyRelation.companyId}/detach",
    "title": "Метод удаления связей квартирограммы и компании",
    "method": "put",
    "service": "access_control",
    "module": "flatgramm",
    "resource": "company_relation",
    "access": "edit",
    "scope": "access_control:flatgramm:company_relation:edit",
    "description": "Метод доступен для: admin, service, seller",
    "params": [
      "flatgrammCompanyRelation.flatgrammId",
      "flatgrammCompanyRelation.companyId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/flatgramm/company_relation/count",
    "title": "Метод получения количества связей квартирограмм и компаний",
    "method": "get",
    "service": "access_control",
    "module": "flatgramm",
    "resource": "company_relation",
    "access": "list",
    "scope": "access_control:flatgramm:company_relation:list",
    "description": "Метод доступен для: admin, service, seller",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/flatgramm/company_relation/list",
    "title": "Метод получения списка связей квартирограмм и компаний",
    "method": "get",
    "service": "access_control",
    "module": "flatgramm",
    "resource": "company_relation",
    "access": "list",
    "scope": "access_control:flatgramm:company_relation:list",
    "description": "Метод доступен для: admin, service, seller",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/flatgramm/count",
    "title": "Метод получения количества квартирограмм",
    "method": "get",
    "service": "access_control",
    "module": "flatgramm",
    "resource": "flatgramm",
    "access": "list",
    "scope": "access_control:flatgramm:list",
    "description": "Для пользователей типов owner, employee: в результат фильтрации попадают только квартирограммы компании пользователя.Для пользователей типов owner, employee: если filter.company_ids непустое и не совпадает с COMPANY_ID пользователя, метод вернет PERMISSION_DENIED = 7 (403 Forbidden).Для пользователей типов owner, employee: если filter.company_ids пустое, то фильтрация по COMPANY_ID пользователя.Метод доступен для: admin, manager, service, bti, ltp_first, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/flatgramm/list",
    "title": "Метод получения списка облегченных квартирограмм",
    "method": "get",
    "service": "access_control",
    "module": "flatgramm",
    "resource": "flatgramm",
    "access": "list",
    "scope": "access_control:flatgramm:list",
    "description": "Для пользователей типов owner, employee: в результат фильтрации попадают только квартирограммы компании пользователя.Для пользователей типов owner, employee: если filter.company_ids непустое и не совпадает с COMPANY_ID пользователя, метод вернет PERMISSION_DENIED = 7 (403 Forbidden).Для пользователей типов owner, employee: если filter.company_ids пустое, то фильтрация по COMPANY_ID пользователя.Метод доступен для: admin, manager, service, bti, ltp_first, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/rfid/{id}",
    "title": "Метод получения ключа",
    "method": "get",
    "service": "access_control",
    "module": "rfid",
    "resource": "rfid",
    "access": "card",
    "scope": "access_control:rfid:card",
    "description": "Метод доступен для: admin, service, ltp_first, owner, employee",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/rfid/count",
    "title": "Метод получения количества ключей",
    "method": "get",
    "service": "access_control",
    "module": "rfid",
    "resource": "rfid",
    "access": "list",
    "scope": "access_control:rfid:list",
    "description": "Метод доступен для: admin, service, ltp_first, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/rfid/list",
    "title": "Метод получения списка ключей",
    "method": "get",
    "service": "access_control",
    "module": "rfid",
    "resource": "rfid",
    "access": "list",
    "scope": "access_control:rfid:list",
    "description": "Метод доступен для: admin, service, ltp_first, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/access_control/api/v1/rfid/{id}",
    "title": "Метод удаления ключа",
    "method": "delete",
    "service": "access_control",
    "module": "rfid",
    "resource": "rfid",
    "access": "remove",
    "scope": "access_control:rfid:remove",
    "description": "Метод доступен для: admin, service, ltp_first, owner, employee",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/access_control/api/v1/rfid",
    "title": "Метод создания ключа",
    "method": "post",
    "service": "access_control",
    "module": "rfid",
    "resource": "rfid",
    "access": "save",
    "scope": "access_control:rfid:save",
    "description": "Метод доступен для: admin, service, ltp_first, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/room/{id}",
    "title": "Метод получения Квартиры",
    "method": "get",
    "service": "access_control",
    "module": "room",
    "resource": "room",
    "access": "card",
    "scope": "access_control:room:card",
    "description": "Метод доступен для: admin, service, ltp_first, owner, employee",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_control/api/v1/room/{roomDevice.orpon}/{roomDevice.roomNumber}/device/{roomDevice.deviceId}/attach",
    "title": "Метод создания связи помещения и устройства",
    "method": "put",
    "service": "access_control",
    "module": "room",
    "resource": "device",
    "access": "edit",
    "scope": "access_control:room:device:edit",
    "description": "Метод доступен для: admin, service",
    "params": [
      "roomDevice.orpon",
      "roomDevice.roomNumber",
      "roomDevice.deviceId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_control/api/v1/room/{roomDevice.orpon}/{roomDevice.roomNumber}/device/{roomDevice.deviceId}/detach",
    "title": "Метод удаления связи помещения и устройства",
    "method": "put",
    "service": "access_control",
    "module": "room",
    "resource": "device",
    "access": "edit",
    "scope": "access_control:room:device:edit",
    "description": "Метод доступен для: admin, service",
    "params": [
      "roomDevice.orpon",
      "roomDevice.roomNumber",
      "roomDevice.deviceId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/room/device/count",
    "title": "Метод получения количества связок помещение-устройство",
    "method": "get",
    "service": "access_control",
    "module": "room",
    "resource": "device",
    "access": "list",
    "scope": "access_control:room:device:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/room/device/list",
    "title": "Метод получения списка связок помещение-устройство",
    "method": "get",
    "service": "access_control",
    "module": "room",
    "resource": "device",
    "access": "list",
    "scope": "access_control:room:device:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/room/count",
    "title": "Метод получения количества квартир",
    "method": "get",
    "service": "access_control",
    "module": "room",
    "resource": "room",
    "access": "list",
    "scope": "access_control:room:list",
    "description": "Метод доступен для: admin, service, ltp_first, owner, employee, bti",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/room/list",
    "title": "Метод получения списка квартир",
    "method": "get",
    "service": "access_control",
    "module": "room",
    "resource": "room",
    "access": "list",
    "scope": "access_control:room:list",
    "description": "Метод доступен для: admin, service, ltp_first, owner, employee, bti",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/room/orpon/{orpon}/number/{roomNumber}/exists",
    "title": "Метод проверки существования квартиры по ОРПОН и её номеру",
    "method": "get",
    "service": "access_control",
    "module": "room",
    "resource": "number:exists",
    "access": "list",
    "scope": "access_control:room:number:exists:list",
    "description": "Возвращает true если найдена квартира с указанными параметрами.Метод доступен для: admin, service",
    "params": [
      "orpon",
      "roomNumber"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "patch:/access_control/api/v1/room/set_subscription_mode",
    "title": "Метод установки режима подписок",
    "method": "patch",
    "service": "access_control",
    "module": "room",
    "resource": "set_subscription_mode",
    "access": "edit",
    "scope": "access_control:room:set_subscription_mode:edit",
    "description": "Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/room/user/count",
    "title": "Метод получения количества связей помещений и пользователей",
    "method": "get",
    "service": "access_control",
    "module": "room",
    "resource": "user",
    "access": "list",
    "scope": "access_control:room:user:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/room/user/list",
    "title": "Метод получения списка связей помещений и пользователей",
    "method": "get",
    "service": "access_control",
    "module": "room",
    "resource": "user",
    "access": "list",
    "scope": "access_control:room:user:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_control/api/v1/system/status",
    "title": "Метод проверки доступности по порту из интернета",
    "method": "get",
    "service": "access_control",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "access_control:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/access_management/api/v1/group_template/{id}",
    "title": "Метод получения шаблона группы",
    "method": "get",
    "service": "access_management",
    "module": "group_template",
    "resource": "group_template",
    "access": "card",
    "scope": "access_management:group_template:card",
    "description": "Метод доступен для: admin, service, bti, seller",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_management/api/v1/group_template/{groupTemplateGroup.groupTemplateId}/group/{groupTemplateGroup.groupId}/attach",
    "title": "Метод сохранения связей шаблонов групп и группы пользователя",
    "method": "put",
    "service": "access_management",
    "module": "group_template",
    "resource": "group",
    "access": "edit",
    "scope": "access_management:group_template:group:edit",
    "description": "Метод доступен для: admin, service",
    "params": [
      "groupTemplateGroup.groupTemplateId",
      "groupTemplateGroup.groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_management/api/v1/group_template/{groupTemplateGroup.groupTemplateId}/group/{groupTemplateGroup.groupId}/detach",
    "title": "Метод удаления связей шаблонов групп и группы пользователя",
    "method": "put",
    "service": "access_management",
    "module": "group_template",
    "resource": "group",
    "access": "edit",
    "scope": "access_management:group_template:group:edit",
    "description": "Метод доступен для: admin, service",
    "params": [
      "groupTemplateGroup.groupTemplateId",
      "groupTemplateGroup.groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group_template/group/count",
    "title": "Метод получения количества связей шаблонов групп и группы пользователя",
    "method": "get",
    "service": "access_management",
    "module": "group_template",
    "resource": "group",
    "access": "list",
    "scope": "access_management:group_template:group:list",
    "description": "Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group_template/group/list",
    "title": "Метод получения списка связей шаблонов групп и группы пользователя",
    "method": "get",
    "service": "access_management",
    "module": "group_template",
    "resource": "group",
    "access": "list",
    "scope": "access_management:group_template:group:list",
    "description": "Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group_template/count",
    "title": "Метод получения количества шаблонов групп",
    "method": "get",
    "service": "access_management",
    "module": "group_template",
    "resource": "group_template",
    "access": "list",
    "scope": "access_management:group_template:list",
    "description": "Метод доступен для: admin, service, bti, seller",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group_template/list",
    "title": "Метод получения списка шаблонов групп",
    "method": "get",
    "service": "access_management",
    "module": "group_template",
    "resource": "group_template",
    "access": "list",
    "scope": "access_management:group_template:list",
    "description": "Метод доступен для: admin, service, bti, seller",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/access_management/api/v1/group_template/{id}",
    "title": "Метод удаления шаблона группы",
    "method": "delete",
    "service": "access_management",
    "module": "group_template",
    "resource": "group_template",
    "access": "remove",
    "scope": "access_management:group_template:remove",
    "description": "Проставляет дату удаления GroupTemplate.deleted_at.Метод доступен для: admin, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/access_management/api/v1/group_template",
    "title": "Метод сохранения шаблона группы",
    "method": "post",
    "service": "access_management",
    "module": "group_template",
    "resource": "group_template",
    "access": "save",
    "scope": "access_management:group_template:save",
    "description": "Поддерживает создание и обновление как UPSERT по GroupTemplate.id.Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/access_management/api/v1/group/by_template",
    "title": "Метод создания группы по шаблону",
    "method": "post",
    "service": "access_management",
    "module": "group",
    "resource": "by_template",
    "access": "save",
    "scope": "access_management:group:by_template:save",
    "description": "Метод доступен для: admin, service, bti, seller",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group/{id}",
    "title": "Метод получения группы",
    "method": "get",
    "service": "access_management",
    "module": "group",
    "resource": "group",
    "access": "card",
    "scope": "access_management:group:card",
    "description": "Метод доступен для: admin, service, bti, seller",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group/claim/exist",
    "title": "Метод проверки наличия назначенных атрибутов пользователя",
    "method": "get",
    "service": "access_management",
    "module": "group",
    "resource": "claim:exist",
    "access": "list",
    "scope": "access_management:group:claim:exist:list",
    "description": "Метод также проверит и атрибуты групп {key=GROUP_ID,value=Group.id}.Бизнес-пользователи получают только свои разрешения, поэтому для всех пользователей, кроме admin, owner, service, bti, seller игнорируются GroupClaimFilter.user_id, GroupClaimFilter.user_data, GroupClaimFilter.api_key_hash, а значения для них берутся из токена.Для admin, owner, service, bti, seller при наличии GroupClaimFilter.user_id отдаем разрешения для указанного GroupClaimFilter.user_id и GroupClaimFilter.user_data, при отсутствии GroupClaimFilter.user_id значения берутся из токена.Для admin, service при наличии GroupClaimFilter.api_key_hash возвращаем Claim с учетом только GroupClaimFilter.api_key_hash.Метод доступен для: admin, master, slave, owner, employee, service, bti, seller, external_seller, ltp_first, mrf, manager",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group/claim/count",
    "title": "Метод получения количества уникальных назначенных атрибутов пользователя",
    "method": "get",
    "service": "access_management",
    "module": "group",
    "resource": "claim",
    "access": "list",
    "scope": "access_management:group:claim:list",
    "description": "Метод также сосчитает и атрибуты групп {key=GROUP_ID,value=Group.id}.Бизнес-пользователи получают только свои разрешения, поэтому для всех пользователей, кроме admin, owner, service, bti, seller игнорируются GroupClaimFilter.user_id, GroupClaimFilter.user_data, GroupClaimFilter.api_key_hash, а значения для них берутся из токена.Для admin, owner, service, bti, seller при наличии GroupClaimFilter.user_id отдаем разрешения для указанного GroupClaimFilter.user_id и GroupClaimFilter.user_data, при отсутствии GroupClaimFilter.user_id значения берутся из токена.Для admin, service при наличии GroupClaimFilter.api_key_hash возвращаем Claim с учетом только GroupClaimFilter.api_key_hash.Метод доступен для: admin, master, slave, owner, employee, service, bti, seller, external_seller, ltp_first, mrf, manager",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group/claim/list",
    "title": "Метод получения уникальных назначенных атрибутов пользователя",
    "method": "get",
    "service": "access_management",
    "module": "group",
    "resource": "claim",
    "access": "list",
    "scope": "access_management:group:claim:list",
    "description": "Метод также возвращает группы пользователя в виде атрибута (Claim) {key=GROUP_ID,value=Group.id}.Бизнес-пользователи получают только свои разрешения, поэтому для всех пользователей, кроме admin, owner, service, bti, seller игнорируются GroupClaimFilter.user_id, GroupClaimFilter.user_data, GroupClaimFilter.api_key_hash, а значения для них берутся из токена.Для admin, owner, service, bti, seller при наличии GroupClaimFilter.user_id отдаем разрешения для указанного GroupClaimFilter.user_id и GroupClaimFilter.user_data, при отсутствии GroupClaimFilter.user_id значения берутся из токена.Для admin, service при наличии GroupClaimFilter.api_key_hash возвращаем Claim с учетом только GroupClaimFilter.api_key_hash.Метод доступен для: admin, master, slave, owner, employee, service, bti, seller, external_seller, ltp_first, mrf, manager",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_management/api/v1/group/{groupId}/api_key/create",
    "title": "Метод добавления ключа доступа ApiKey",
    "method": "put",
    "service": "access_management",
    "module": "group",
    "resource": "create",
    "access": "edit",
    "scope": "access_management:group:create:edit",
    "description": "Метод доступен для: admin",
    "params": [
      "groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_management/api/v1/group/{groupId}/api_key/delete",
    "title": "Метод удаления ключей доступа ApiKey",
    "method": "put",
    "service": "access_management",
    "module": "group",
    "resource": "delete",
    "access": "edit",
    "scope": "access_management:group:delete:edit",
    "description": "Метод доступен для: admin",
    "params": [
      "groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group/count",
    "title": "Метод получения количества групп",
    "method": "get",
    "service": "access_management",
    "module": "group",
    "resource": "group",
    "access": "list",
    "scope": "access_management:group:list",
    "description": "Метод доступен для: admin, service, bti, seller",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group/list",
    "title": "Метод получения списка групп",
    "method": "get",
    "service": "access_management",
    "module": "group",
    "resource": "group",
    "access": "list",
    "scope": "access_management:group:list",
    "description": "Метод доступен для: admin, service, bti, seller",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/access_management/api/v1/group/{id}",
    "title": "Метод удаления группы",
    "method": "delete",
    "service": "access_management",
    "module": "group",
    "resource": "group",
    "access": "remove",
    "scope": "access_management:group:remove",
    "description": "Метод доступен для: admin, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/access_management/api/v1/group",
    "title": "Метод сохранения группы",
    "method": "post",
    "service": "access_management",
    "module": "group",
    "resource": "group",
    "access": "save",
    "scope": "access_management:group:save",
    "description": "Поддерживает создание и обновление как UPSERT по Group.id.Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_management/api/v1/group/{userGroup.groupId}/user/{userGroup.userId}/attach",
    "title": "Метод привязки пользователя к группе",
    "method": "put",
    "service": "access_management",
    "module": "group",
    "resource": "user",
    "access": "edit",
    "scope": "access_management:group:user:edit",
    "description": "Метод доступен для: admin, owner, service, bti, seller",
    "params": [
      "userGroup.groupId",
      "userGroup.userId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/access_management/api/v1/group/{userGroup.groupId}/user/{userGroup.userId}/detach",
    "title": "Метод удаления привязки пользователя к группе",
    "method": "put",
    "service": "access_management",
    "module": "group",
    "resource": "user",
    "access": "edit",
    "scope": "access_management:group:user:edit",
    "description": "Метод доступен для: admin, owner, service, bti, seller",
    "params": [
      "userGroup.groupId",
      "userGroup.userId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group/user/count",
    "title": "Метод получения количества связей пользователей и групп",
    "method": "get",
    "service": "access_management",
    "module": "group",
    "resource": "user",
    "access": "list",
    "scope": "access_management:group:user:list",
    "description": "Метод доступен для: admin, owner, service, bti, seller",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/group/user/list",
    "title": "Метод получения списка связей пользователей и групп",
    "method": "get",
    "service": "access_management",
    "module": "group",
    "resource": "user",
    "access": "list",
    "scope": "access_management:group:user:list",
    "description": "Метод доступен для: admin, owner, service, bti, seller",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/access_management/api/v1/system/status",
    "title": "Метод проверки доступности по порту из интернета",
    "method": "get",
    "service": "access_management",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "access_management:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/ad/api/v1/marketplace/{id}",
    "title": "Метод получения маркетплейса",
    "method": "get",
    "service": "ad",
    "module": "marketplace",
    "resource": "marketplace",
    "access": "card",
    "scope": "ad:marketplace:card",
    "description": "Не требует авторизации",
    "params": [
      "id"
    ],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/ad/api/v1/marketplace/count",
    "title": "Метод получения количества маркетплейсов",
    "method": "get",
    "service": "ad",
    "module": "marketplace",
    "resource": "marketplace",
    "access": "list",
    "scope": "ad:marketplace:list",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/ad/api/v1/marketplace/list",
    "title": "Метод получения списка маркетплейсов",
    "method": "get",
    "service": "ad",
    "module": "marketplace",
    "resource": "marketplace",
    "access": "list",
    "scope": "ad:marketplace:list",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/ad/api/v1/marketplace",
    "title": "Метод сохранения маркетплейса",
    "method": "post",
    "service": "ad",
    "module": "marketplace",
    "resource": "marketplace",
    "access": "save",
    "scope": "ad:marketplace:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: manager, service, application(ad:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/ad/api/v1/salepoint/{id}",
    "title": "Метод получения точки продаж",
    "method": "get",
    "service": "ad",
    "module": "salepoint",
    "resource": "salepoint",
    "access": "card",
    "scope": "ad:salepoint:card",
    "description": "Не требует авторизации",
    "params": [
      "id"
    ],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/ad/api/v1/salepoint/count",
    "title": "Метод получения количества точек продаж",
    "method": "get",
    "service": "ad",
    "module": "salepoint",
    "resource": "salepoint",
    "access": "list",
    "scope": "ad:salepoint:list",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/ad/api/v1/salepoint/list",
    "title": "Метод получения списка точек продаж",
    "method": "get",
    "service": "ad",
    "module": "salepoint",
    "resource": "salepoint",
    "access": "list",
    "scope": "ad:salepoint:list",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/ad/api/v1/salepoint",
    "title": "Метод сохранения точки продаж",
    "method": "post",
    "service": "ad",
    "module": "salepoint",
    "resource": "salepoint",
    "access": "save",
    "scope": "ad:salepoint:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: manager, service, application(ad:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/ad/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "ad",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "ad:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/banner/api/v1/banner_lite/{id}",
    "title": "Метод получения упрощённого баннера",
    "method": "get",
    "service": "banner",
    "module": "banner_lite",
    "resource": "banner_lite",
    "access": "card",
    "scope": "banner:banner_lite:card",
    "description": "Не требует авторизации",
    "params": [
      "id"
    ],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "lite"
  },
  {
    "name": "get:/banner/api/v1/banner_lite/list",
    "title": "Метод получения списка упрощённых баннеров",
    "method": "get",
    "service": "banner",
    "module": "banner_lite",
    "resource": "banner_lite",
    "access": "list",
    "scope": "banner:banner_lite:list",
    "description": "Возвращает всегда активные баннеры.По умолчанию возвращает первые 20 баннеров осортированных по приоритету, затем по дате начала акции(от самых важных к не важным, затем от самых новых акций к самым старым).Если запрос выполнен хотя бы без одного изпризнака приложения возвращает пустой список.Если запрос выполнен без признаков пользователя метод возвращает пустой список.Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "lite"
  },
  {
    "name": "get:/banner/api/v1/banner/{id}",
    "title": "Метод получения баннера",
    "method": "get",
    "service": "banner",
    "module": "banner",
    "resource": "banner",
    "access": "card",
    "scope": "banner:card",
    "description": "Метод доступен для: admin, manager, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/banner/api/v1/banner/count",
    "title": "Метод получения количества баннеров",
    "method": "get",
    "service": "banner",
    "module": "banner",
    "resource": "banner",
    "access": "list",
    "scope": "banner:list",
    "description": "Метод доступен для: admin, manager, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/banner/api/v1/banner/list",
    "title": "Метод получения списка баннеров",
    "method": "get",
    "service": "banner",
    "module": "banner",
    "resource": "banner",
    "access": "list",
    "scope": "banner:list",
    "description": "Метод доступен для: admin, manager, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/banner/api/v1/banner",
    "title": "Метод сохранения баннера",
    "method": "post",
    "service": "banner",
    "module": "banner",
    "resource": "banner",
    "access": "save",
    "scope": "banner:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: admin, manager, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/banner/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "banner",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "banner:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "post:/banner/api/v1/banner/{bannerId}/upload_image",
    "title": "Метод загрузки картинки баннера",
    "method": "post",
    "service": "banner",
    "module": "banner",
    "resource": "upload_image",
    "access": "save",
    "scope": "banner:upload_image:save",
    "description": "Метод доступен для: admin, manager, service",
    "params": [
      "bannerId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/bell/api/v1/notification/{id}",
    "title": "Метод получения уведомления",
    "method": "get",
    "service": "bell",
    "module": "notification",
    "resource": "notification",
    "access": "card",
    "scope": "bell:notification:card",
    "description": "Метод доступен для: admin, manager, master, slave, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/bell/api/v1/notification/count",
    "title": "Метод получения количества уведомлений",
    "method": "get",
    "service": "bell",
    "module": "notification",
    "resource": "notification",
    "access": "list",
    "scope": "bell:notification:list",
    "description": "Метод доступен для: admin, manager, master, slave, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/bell/api/v1/notification/list",
    "title": "Метод получения списка уведомлений",
    "method": "get",
    "service": "bell",
    "module": "notification",
    "resource": "notification",
    "access": "list",
    "scope": "bell:notification:list",
    "description": "Метод доступен для: admin, manager, master, slave, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/bell/api/v1/notification",
    "title": "Метод сохранения уведомления",
    "method": "post",
    "service": "bell",
    "module": "notification",
    "resource": "notification",
    "access": "save",
    "scope": "bell:notification:save",
    "description": "Поддерживает только создание.Метод доступен для: service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/bell/api/v1/notification/view/orpon/{orpon}/room_number/{roomNumber}",
    "title": "Метод изменения статуса уведомлений на \"Просмотрено\" по ОРПОНу и номеру квартиры",
    "method": "post",
    "service": "bell",
    "module": "notification",
    "resource": "view",
    "access": "save",
    "scope": "bell:notification:view:save",
    "description": "Метод доступен для: master, slave, service",
    "params": [
      "orpon",
      "roomNumber"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/bell/api/v1/notification/{id}/view",
    "title": "Метод изменения статуса уведомления на \"Просмотрено\"",
    "method": "post",
    "service": "bell",
    "module": "notification",
    "resource": "view",
    "access": "save",
    "scope": "bell:notification:view:save",
    "description": "Метод доступен для: master, slave, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/bell/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "bell",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "bell:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/device/api/v1/device/{id}",
    "title": "Метод получаения устройства",
    "method": "get",
    "service": "device",
    "module": "device",
    "resource": "device",
    "access": "card",
    "scope": "device:card",
    "description": "Метод доступен для: admin, service, owner, employee, bti, ltp_first",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/cms_phone/{id}",
    "title": "Метод получения аналоговой трубки по идентификатору",
    "method": "get",
    "service": "device",
    "module": "cms_phone",
    "resource": "cms_phone",
    "access": "card",
    "scope": "device:cms_phone:card",
    "description": "Метод доступен для: admin, service, owner, employee, bti, ltp_first",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/cms_phone/count",
    "title": "Метод получения количества аналоговых трубок",
    "method": "get",
    "service": "device",
    "module": "cms_phone",
    "resource": "cms_phone",
    "access": "list",
    "scope": "device:cms_phone:list",
    "description": "Метод доступен для: admin, service, owner, employee, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/cms_phone/list",
    "title": "Метод получения списка аналоговых трубок",
    "method": "get",
    "service": "device",
    "module": "cms_phone",
    "resource": "cms_phone",
    "access": "list",
    "scope": "device:cms_phone:list",
    "description": "Метод доступен для: admin, service, owner, employee, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/device/api/v1/cms_phone/refresh",
    "title": "Метод для принудительного обновления статуса аналоговых трубок",
    "method": "post",
    "service": "device",
    "module": "cms_phone",
    "resource": "refresh",
    "access": "save",
    "scope": "device:cms_phone:refresh:save",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/device/api/v1/cms_phone/device_id/{deviceId}",
    "title": "Метод удаления аналоговой трубки по идентификатору устройсва",
    "method": "delete",
    "service": "device",
    "module": "cms_phone",
    "resource": "cms_phone",
    "access": "remove",
    "scope": "device:cms_phone:remove",
    "description": "Метод доступен для: admin, service",
    "params": [
      "deviceId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/device/api/v1/cms_phone/orpon/{orpon}/room_number/{roomNumber}/device_id/{deviceId}",
    "title": "Метод удаления аналоговой трубки по идентификатору ОРПОН, номеру квартиры и идентификатору устройства",
    "method": "delete",
    "service": "device",
    "module": "cms_phone",
    "resource": "cms_phone",
    "access": "remove",
    "scope": "device:cms_phone:remove",
    "description": "Метод доступен для: admin, service",
    "params": [
      "orpon",
      "roomNumber",
      "deviceId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/device/api/v1/cms_phone/orpon_id/{orponId}",
    "title": "Метод удаления аналоговой трубки по идентификатору ОРПОН",
    "method": "delete",
    "service": "device",
    "module": "cms_phone",
    "resource": "cms_phone",
    "access": "remove",
    "scope": "device:cms_phone:remove",
    "description": "Метод доступен для: admin, service",
    "params": [
      "orponId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/device/api/v1/cms_phone/orpon_id/{orponId}/room_number/{roomNumber}",
    "title": "Метод удаления аналоговой трубки по идентификатору ОРПОН и номеру квартиры",
    "method": "delete",
    "service": "device",
    "module": "cms_phone",
    "resource": "cms_phone",
    "access": "remove",
    "scope": "device:cms_phone:remove",
    "description": "Метод доступен для: admin, service",
    "params": [
      "orponId",
      "roomNumber"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/device/api/v1/cms_phone/{id}",
    "title": "Метод удаления аналоговой трубки",
    "method": "delete",
    "service": "device",
    "module": "cms_phone",
    "resource": "cms_phone",
    "access": "remove",
    "scope": "device:cms_phone:remove",
    "description": "Метод доступен для: admin, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/device/configuration_status/grouped/count",
    "title": "Метод получения количества конфигураций сгруппированных по устройствам",
    "method": "get",
    "service": "device",
    "module": "device",
    "resource": "configuration_status:grouped",
    "access": "list",
    "scope": "device:configuration_status:grouped:list",
    "description": "Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/device/configuration_status/grouped/list",
    "title": "Метод получения списка конфигураций сгруппированных по устройствам",
    "method": "get",
    "service": "device",
    "module": "device",
    "resource": "configuration_status:grouped",
    "access": "list",
    "scope": "device:configuration_status:grouped:list",
    "description": "Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/device/api/v1/device/configuration_status",
    "title": "Метод изменения статуса конфигурации устройства",
    "method": "post",
    "service": "device",
    "module": "device",
    "resource": "configuration_status",
    "access": "save",
    "scope": "device:configuration_status:save",
    "description": "Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/device/{id}/configuration_statuses",
    "title": "Метод получения статусов конфигурации устройства",
    "method": "get",
    "service": "device",
    "module": "device",
    "resource": "configuration_statuses",
    "access": "list",
    "scope": "device:configuration_statuses:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/device_lite/{id}",
    "title": "Метод получаения упрощенного устройства",
    "method": "get",
    "service": "device",
    "module": "device_lite",
    "resource": "device_lite",
    "access": "card",
    "scope": "device:device_lite:card",
    "description": "Метод доступен для: admin, service, owner, employee, bti, ltp_first.Метод доступен для: ApiKey",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "lite"
  },
  {
    "name": "put:/device/api/v1/device",
    "title": "Метод изменения устройства",
    "method": "put",
    "service": "device",
    "module": "device",
    "resource": "device",
    "access": "edit",
    "scope": "device:edit",
    "description": "Метод доступен для: admin, bti, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/device/api/v1/device/{id}/install_preset",
    "title": "Метод установки пресета на устройство",
    "method": "post",
    "service": "device",
    "module": "device",
    "resource": "install_preset",
    "access": "save",
    "scope": "device:install_preset:save",
    "description": "Метод доступен для: admin, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/device/count",
    "title": "Метод получения количества устройств",
    "method": "get",
    "service": "device",
    "module": "device",
    "resource": "device",
    "access": "list",
    "scope": "device:list",
    "description": "Метод доступен для: admin, service, owner, employee, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/device/list",
    "title": "Метод получения списка устройств",
    "method": "get",
    "service": "device",
    "module": "device",
    "resource": "device",
    "access": "list",
    "scope": "device:list",
    "description": "Метод доступен для: admin, service, owner, employee, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/device/api/v1/device/{id}/reconfigure",
    "title": "Метод переконфигурирования устройста",
    "method": "post",
    "service": "device",
    "module": "device",
    "resource": "reconfigure",
    "access": "save",
    "scope": "device:reconfigure:save",
    "description": "Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=630337555.Метод доступен для: admin, bti, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/device/api/v1/device/{id}",
    "title": "Метод удаления устройства",
    "method": "delete",
    "service": "device",
    "module": "device",
    "resource": "device",
    "access": "remove",
    "scope": "device:remove",
    "description": "Метод доступен для: admin, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/device/api/v1/device/{id}/replace",
    "title": "Метод замены устройста",
    "method": "post",
    "service": "device",
    "module": "device",
    "resource": "replace",
    "access": "save",
    "scope": "device:replace:save",
    "description": "Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=655256574.Метод доступен для: admin, bti, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/device/api/v1/device",
    "title": "Метод создания устройства",
    "method": "post",
    "service": "device",
    "module": "device",
    "resource": "device",
    "access": "save",
    "scope": "device:save",
    "description": "Метод доступен для: admin, bti, service, owner, employee.Для owner, employee доступно создание и редактирование только в КВГ, привязанных к компании пользователя",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/sip_phone/{id}",
    "title": "Метод получения SIP-трубки по идентификатору",
    "method": "get",
    "service": "device",
    "module": "sip_phone",
    "resource": "sip_phone",
    "access": "card",
    "scope": "device:sip_phone:card",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/sip_phone/count",
    "title": "Метод получения количества SIP-трубок",
    "method": "get",
    "service": "device",
    "module": "sip_phone",
    "resource": "sip_phone",
    "access": "list",
    "scope": "device:sip_phone:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/sip_phone/list",
    "title": "Метод получения списка SIP-трубок",
    "method": "get",
    "service": "device",
    "module": "sip_phone",
    "resource": "sip_phone",
    "access": "list",
    "scope": "device:sip_phone:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/device/api/v1/sip_phone/get_count",
    "title": "Метод получения количества SIP-трубок",
    "method": "post",
    "service": "device",
    "module": "sip_phone",
    "resource": "sip_phone",
    "access": "save",
    "scope": "device:sip_phone:save",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/device/api/v1/sip_phone/get_list",
    "title": "Метод получения списка SIP-трубок",
    "method": "post",
    "service": "device",
    "module": "sip_phone",
    "resource": "sip_phone",
    "access": "save",
    "scope": "device:sip_phone:save",
    "description": "Метод доступен для: admin, service, bti, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/device/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "device",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "device:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/device/internal/api/v1/trunk_config/{id}",
    "title": "Метод получения trunk-конфигурации",
    "method": "get",
    "service": "device",
    "module": "trunk_config",
    "resource": "trunk_config",
    "access": "card",
    "scope": "device:trunk_config:card",
    "description": "Метод доступен для: admin, bti, service, ltp_first",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "get:/device/internal/api/v1/trunk_config/count",
    "title": "Метод получения количества trunk-конфигураций",
    "method": "get",
    "service": "device",
    "module": "trunk_config",
    "resource": "trunk_config",
    "access": "list",
    "scope": "device:trunk_config:list",
    "description": "Метод доступен для: admin, bti, service, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "get:/device/internal/api/v1/trunk_config/list",
    "title": "Метод получения списка trunk-конфигураций",
    "method": "get",
    "service": "device",
    "module": "trunk_config",
    "resource": "trunk_config",
    "access": "list",
    "scope": "device:trunk_config:list",
    "description": "Метод доступен для: admin, bti, service, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "delete:/device/internal/api/v1/trunk_config/{id}",
    "title": "Метод архивации trunk-конфигурации",
    "method": "delete",
    "service": "device",
    "module": "trunk_config",
    "resource": "trunk_config",
    "access": "remove",
    "scope": "device:trunk_config:remove",
    "description": "Метод доступен для: admin, service, device_admin",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "post:/device/internal/api/v1/trunk_config/restore/{id}",
    "title": "Метод разархивации trunk-конфигурации",
    "method": "post",
    "service": "device",
    "module": "trunk_config",
    "resource": "restore",
    "access": "save",
    "scope": "device:trunk_config:restore:save",
    "description": "Метод доступен для: admin, service, device_admin",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "post:/device/internal/api/v1/trunk_config",
    "title": "Метод создания trunk-конфигурации",
    "method": "post",
    "service": "device",
    "module": "trunk_config",
    "resource": "trunk_config",
    "access": "save",
    "scope": "device:trunk_config:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: admin, bti, service, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "post:/dial/internal/api/v1/broadcast_alert/start",
    "title": "Метод запуска массового оповещения через домофоны",
    "method": "post",
    "service": "dial",
    "module": "broadcast_alert",
    "resource": "start",
    "access": "save",
    "scope": "dial:broadcast_alert:start:save",
    "description": "Метод доступен для: ApiKey",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "get:/dial/internal/api/v1/sip_login",
    "title": "Метод получения sip-логина устройства",
    "method": "get",
    "service": "dial",
    "module": "sip_login",
    "resource": "sip_login",
    "access": "list",
    "scope": "dial:sip_login:list",
    "description": "Метод доступен для: ApiKey",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "get:/ecosystem/api/v1/lego_adapter/service/check/{orpon}/{roomNumber}/{serviceType}",
    "title": "Метод проверки услуги",
    "method": "get",
    "service": "ecosystem",
    "module": "lego_adapter",
    "resource": "service:check",
    "access": "list",
    "scope": "ecosystem:lego_adapter:service:check:list",
    "description": "Возвращает true если хотя бы у одного аккаунта на квартире есть нужный сервис и он содержит активный компонент.Метод доступен для: admin, service",
    "params": [
      "orpon",
      "roomNumber",
      "serviceType"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/ecosystem/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "ecosystem",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "ecosystem:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/encryption_profile/api/v1/encryption_profile/{id}",
    "title": "Метод получения профиля шифрования по идентификатору",
    "method": "get",
    "service": "encryption_profile",
    "module": "encryption_profile",
    "resource": "encryption_profile",
    "access": "card",
    "scope": "encryption_profile:card",
    "description": "Метод доступен для: admin, service, bti, device_admin",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/encryption_profile/api/v1/encryption_profile/count",
    "title": "Метод получения количества профилей шифрования",
    "method": "get",
    "service": "encryption_profile",
    "module": "encryption_profile",
    "resource": "encryption_profile",
    "access": "list",
    "scope": "encryption_profile:list",
    "description": "Метод доступен для: admin, service, bti, device_admin",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/encryption_profile/api/v1/encryption_profile/list",
    "title": "Метод получения списка профилей шифрования",
    "method": "get",
    "service": "encryption_profile",
    "module": "encryption_profile",
    "resource": "encryption_profile",
    "access": "list",
    "scope": "encryption_profile:list",
    "description": "Метод доступен для: admin, service, bti, device_admin",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/encryption_profile/api/v1/encryption_profile/{id}",
    "title": "Метод удаления профиля шифрования",
    "method": "delete",
    "service": "encryption_profile",
    "module": "encryption_profile",
    "resource": "encryption_profile",
    "access": "remove",
    "scope": "encryption_profile:remove",
    "description": "Метод доступен для: admin, service, device_admin",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/encryption_profile/api/v1/encryption_profile/restore/{id}",
    "title": "Метод разархивации шифрования по идентификатору",
    "method": "post",
    "service": "encryption_profile",
    "module": "encryption_profile",
    "resource": "restore",
    "access": "save",
    "scope": "encryption_profile:restore:save",
    "description": "Метод доступен для: admin, service, device_admin",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/encryption_profile/api/v1/encryption_profile",
    "title": "Метод сохранения шифрования по идентификатору",
    "method": "post",
    "service": "encryption_profile",
    "module": "encryption_profile",
    "resource": "encryption_profile",
    "access": "save",
    "scope": "encryption_profile:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: device_admin",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/encryption_profile/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "encryption_profile",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "encryption_profile:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "post:/preset/api/v1/event/preset/{id}/install",
    "title": "Метод установки пресета",
    "method": "post",
    "service": "preset",
    "module": "event",
    "resource": "preset:install",
    "access": "save",
    "scope": "event:preset:install:save",
    "description": "Метод доступен для: admin, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/exchange/api/v1/message_mobile_push_call",
    "title": "Метод отправки задач и получения их результатов выполнения для мобильного приложения",
    "method": "post",
    "service": "exchange",
    "module": "message_mobile_push_call",
    "resource": "message_mobile_push_call",
    "access": "save",
    "scope": "exchange:message_mobile_push_call:save",
    "description": "Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/exchange/api/v1/message_push_call",
    "title": "Метод отправки задач и получения их результатов выполнения",
    "method": "post",
    "service": "exchange",
    "module": "message_push_call",
    "resource": "message_push_call",
    "access": "save",
    "scope": "exchange:message_push_call:save",
    "description": "Метод доступен для: admin, service, application(exchange:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/exchange/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "exchange",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "exchange:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "post:/identity_b2b/api/v1/authorization/check_code",
    "title": "Метод проверки кода двухфакторной авторизации и активация сессии",
    "method": "post",
    "service": "identity_b2b",
    "module": "authorization",
    "resource": "check_code",
    "access": "save",
    "scope": "identity_b2b:authorization:check_code:save",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/identity_b2b/api/v1/authorization/login_by_password",
    "title": "Метод авторизации для B2B по паролю",
    "method": "post",
    "service": "identity_b2b",
    "module": "authorization",
    "resource": "login_by_password",
    "access": "save",
    "scope": "identity_b2b:authorization:login_by_password:save",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/identity_b2b/api/v1/authorization/login",
    "title": "Метод авторизации по ОТП-коду для B2B",
    "method": "post",
    "service": "identity_b2b",
    "module": "authorization",
    "resource": "login",
    "access": "save",
    "scope": "identity_b2b:authorization:login:save",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/identity_b2b/api/v1/authorization/send_code",
    "title": "Метод запроса ОТП-кода для B2B",
    "method": "post",
    "service": "identity_b2b",
    "module": "authorization",
    "resource": "send_code",
    "access": "save",
    "scope": "identity_b2b:authorization:send_code:save",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/identity_b2b/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "identity_b2b",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "identity_b2b:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "post:/identity/api/v1/authorization/login_by_password",
    "title": "Метод авторизации по паролю",
    "method": "post",
    "service": "identity",
    "module": "authorization",
    "resource": "login_by_password",
    "access": "save",
    "scope": "identity:authorization:login_by_password:save",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/identity/api/v1/authorization/login",
    "title": "Метод авторизации по ОТП-коду",
    "method": "post",
    "service": "identity",
    "module": "authorization",
    "resource": "login",
    "access": "save",
    "scope": "identity:authorization:login:save",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/identity/api/v1/authorization/send_code",
    "title": "Метод запроса ОТП-кода",
    "method": "post",
    "service": "identity",
    "module": "authorization",
    "resource": "send_code",
    "access": "save",
    "scope": "identity:authorization:send_code:save",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/identity/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "identity",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "identity:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "post:/identity/internal/api/v1/token/user/{userId}",
    "title": "Метод получения токена по идентификатору пользователя",
    "method": "post",
    "service": "identity",
    "module": "token",
    "resource": "user",
    "access": "save",
    "scope": "identity:token:user:save",
    "description": "Метод доступен для: service",
    "params": [
      "userId"
    ],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "post:/invoice/internal/api/v1/invoice/confirm",
    "title": "Метод подтверждения платежа (вызывается со стороны внешней системы)",
    "method": "post",
    "service": "invoice",
    "module": "invoice",
    "resource": "confirm",
    "access": "save",
    "scope": "invoice:confirm:save",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "get:/invoice/api/v1/invoice/count",
    "title": "Метод получения количества платежей",
    "method": "get",
    "service": "invoice",
    "module": "invoice",
    "resource": "invoice",
    "access": "list",
    "scope": "invoice:list",
    "description": "Для master в параметр filter.user_id подставляется user_id из токена.Метод доступен для: admin, service, master, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/invoice/api/v1/invoice/list",
    "title": "Метод получения списка платежей",
    "method": "get",
    "service": "invoice",
    "module": "invoice",
    "resource": "invoice",
    "access": "list",
    "scope": "invoice:list",
    "description": "Для master доступно получение только собственных платежей, если параметр filter.user_id передан и не совпадает с user_id из токена, возвращается ошибка доступа.Метод доступен для: admin, service, master, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/invoice/api/v1/invoice/{invoiceId}",
    "title": "Метод получения платежа",
    "method": "get",
    "service": "invoice",
    "module": "invoice",
    "resource": "invoice",
    "access": "list",
    "scope": "invoice:list",
    "description": "Для master доступно получение платежа только с user_id из токена.Метод доступен для: admin, service, master",
    "params": [
      "invoiceId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/invoice/api/v1/pay_method/bankcard",
    "title": "Метод добавления способа оплаты с типом \"Банковская карта\"",
    "method": "post",
    "service": "invoice",
    "module": "pay_method",
    "resource": "bankcard",
    "access": "save",
    "scope": "invoice:pay_method:bankcard:save",
    "description": "Добавляется банковская карта для пользователя из токена.Метод доступен для: master",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/invoice/api/v1/pay_method/{payMethodId}/default",
    "title": "Метод установки способа оплаты по умолчанию",
    "method": "post",
    "service": "invoice",
    "module": "pay_method",
    "resource": "default",
    "access": "save",
    "scope": "invoice:pay_method:default:save",
    "description": "Изменяются способы оплаты для пользователя из токена.Метод доступен для: master",
    "params": [
      "payMethodId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/invoice/api/v1/pay_method/list",
    "title": "Метод получения списка способов оплаты",
    "method": "get",
    "service": "invoice",
    "module": "pay_method",
    "resource": "pay_method",
    "access": "list",
    "scope": "invoice:pay_method:list",
    "description": "Для роли master возвращаются способы оплаты для пользователя из токена.Для роли service возвращаются способы оплаты пользователя, указанного в параметре запроса.Метод доступен для: service, master",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/invoice/api/v1/pay_method/{payMethodId}",
    "title": "Метод удаления способа оплаты",
    "method": "delete",
    "service": "invoice",
    "module": "pay_method",
    "resource": "pay_method",
    "access": "remove",
    "scope": "invoice:pay_method:remove",
    "description": "Удаляются способы оплаты для пользователя из токена.Метод доступен для: master",
    "params": [
      "payMethodId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/invoice/api/v1/pay_method/sbp",
    "title": "Метод добавления способа оплаты с типом \"СБП\"",
    "method": "post",
    "service": "invoice",
    "module": "pay_method",
    "resource": "sbp",
    "access": "save",
    "scope": "invoice:pay_method:sbp:save",
    "description": "Добавляется СБП для пользователя из токена.Метод доступен для: master",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/invoice/api/v1/invoice",
    "title": "Метод создания платежа",
    "method": "post",
    "service": "invoice",
    "module": "invoice",
    "resource": "invoice",
    "access": "save",
    "scope": "invoice:save",
    "description": "Создание платежа в своей и внешней платежной системе.Метод доступен для: service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/jwks/api/v1/key/.well-known/jwks.json",
    "title": "Метод получения публичных ключей",
    "method": "get",
    "service": "jwks",
    "module": "key",
    "resource": ".well-known:jwks.json",
    "access": "list",
    "scope": "jwks:key:.well-known:jwks.json:list",
    "description": "Возвращает три последних публичных ключа.Используется партнёрами, с помощью публичного ключа проверяется подпись в JWT, выпущенных платформой Ключ.Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695865.Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/jwks/internal/api/v1/key/{id}",
    "title": "Метод удаления публичного ключа",
    "method": "delete",
    "service": "jwks",
    "module": "key",
    "resource": "key",
    "access": "remove",
    "scope": "jwks:key:remove",
    "description": "Используется сервисом KMS.Метод доступен для: service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "post:/jwks/internal/api/v1/key",
    "title": "Метод сохранения публичного ключа",
    "method": "post",
    "service": "jwks",
    "module": "key",
    "resource": "key",
    "access": "save",
    "scope": "jwks:key:save",
    "description": "Используется сервисом KMS.Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695357.Метод доступен для: service",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "get:/jwks/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "jwks",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "jwks:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "post:/kms/internal/api/v1/kms/jwt/create/jwe",
    "title": "Метод создание nested JWT токена",
    "method": "post",
    "service": "kms",
    "module": "kms",
    "resource": "jwt:create:jwe",
    "access": "save",
    "scope": "kms:jwt:create:jwe:save",
    "description": "Создаёт JWT токен с клеймами переданными в PayloadData, подписывает последним выпущенным приватным ключом платформы Ключ.Токен шифруетется (JWE) публичным ключом, переданным в параметре public_key (обычно это публичный ключ партнёра).Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695865.Метод доступен для: service",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "post:/kms/internal/api/v1/kms/key/generate",
    "title": "Метод генерации пары ключей",
    "method": "post",
    "service": "kms",
    "module": "kms",
    "resource": "key:generate",
    "access": "save",
    "scope": "kms:key:generate:save",
    "description": "Генерирует публичный и приватный ключи.Приватный ключ шифруется алгоритмом AES-GCM и сохранятеся в колонке kms.key_infos.encrypted_private_key.Формат хранения приватного ключа - строковое представление JSON: состоит из переменных:- Nonce: Number used once - представляет собой уникальный набор битов, используется один раз при шифровании блока данных в режиме GCM.- EncryptedString: зашифрованный приватный ключ в формате DER.- Tag: Message Authentication Code, используется для проверки целостности и подлинности данных после их расшифровки.Публичный ключ сохранятеся в колонке kms.key_infos.public_key в формате DER и передаётся в сервис JWKS методом PostKey.Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695357.Метод доступен для: admin, manager, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "get:/kms/internal/api/v1/kms/key/list",
    "title": "Метод получения ключей",
    "method": "get",
    "service": "kms",
    "module": "kms",
    "resource": "key",
    "access": "list",
    "scope": "kms:key:list",
    "description": "Возвращает три последних ключа отсортированных по created_at DESC.Используется в административном интерфейсе, для отображения даты выпуска последней пары ключей.Сценарий использвания: https://confluence.rt.ru/pages/viewpage.action?pageId=682907591.Метод доступен для: admin, manager, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "internal",
    "specific": "default"
  },
  {
    "name": "get:/kms/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "kms",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "kms:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/multiapp/api/v1/app_lite/{id}",
    "title": "Метод получения упрощённого приложения",
    "method": "get",
    "service": "multiapp",
    "module": "app_lite",
    "resource": "app_lite",
    "access": "card",
    "scope": "multiapp:app_lite:card",
    "description": "Не требует авторизации",
    "params": [
      "id"
    ],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "lite"
  },
  {
    "name": "get:/multiapp/api/v1/app_lite/count",
    "title": "Метод получения количества упрощённых приложений",
    "method": "get",
    "service": "multiapp",
    "module": "app_lite",
    "resource": "app_lite",
    "access": "list",
    "scope": "multiapp:app_lite:list",
    "description": "Учитывает приложения не в статусе DELETED.Если не передан параметр app_lite_tag.platform_type возвращает 0.Если не передан параметр app_lite_tag.app_name возвращает 0.Если не передан параметр user_tags, либо user_tags пустой, возвращает 0.На основе переданных параметра app_lite_tag формируются app_tags по правилу: https://confluence.rt.ru/pages/viewpage.action?pageId=734713874.Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "lite"
  },
  {
    "name": "get:/multiapp/api/v1/app_lite/list",
    "title": "Метод получения списка упрощённых приложений",
    "method": "get",
    "service": "multiapp",
    "module": "app_lite",
    "resource": "app_lite",
    "access": "list",
    "scope": "multiapp:app_lite:list",
    "description": "Возвращает приложения не в статусе DELETED.Если не передан параметр app_lite_tag.platform_type возвращает пустой список.Если не передан параметр app_lite_tag.app_name возвращает пустой список.Если не передан параметр user_tags, либо user_tags пустой, возвращает пустой список.На основе переданных параметра app_lite_tag формируются app_tags по правилу: https://confluence.rt.ru/pages/viewpage.action?pageId=734713874.Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695692.Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "lite"
  },
  {
    "name": "get:/multiapp/api/v1/app/{id}",
    "title": "Метод получения приложения",
    "method": "get",
    "service": "multiapp",
    "module": "app",
    "resource": "app",
    "access": "card",
    "scope": "multiapp:app:card",
    "description": "Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=682907591.Метод доступен для: admin, manager, service, ltp_first",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/app/{id}/code",
    "title": "Метод получения кода для перехода в приложение",
    "method": "get",
    "service": "multiapp",
    "module": "app",
    "resource": "code",
    "access": "list",
    "scope": "multiapp:app:code:list",
    "description": "Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695692.Метод доступен для: admin, service, master, slave",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/app/count",
    "title": "Метод получения количества приложений",
    "method": "get",
    "service": "multiapp",
    "module": "app",
    "resource": "app",
    "access": "list",
    "scope": "multiapp:app:list",
    "description": "Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695692.Метод доступен для: admin, manager, service, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/app/list",
    "title": "Метод получения списка приложений",
    "method": "get",
    "service": "multiapp",
    "module": "app",
    "resource": "app",
    "access": "list",
    "scope": "multiapp:app:list",
    "description": "Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=682907591.Метод доступен для: admin, manager, service, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/multiapp/api/v1/app/{id}",
    "title": "Метод удаления приложения",
    "method": "delete",
    "service": "multiapp",
    "module": "app",
    "resource": "app",
    "access": "remove",
    "scope": "multiapp:app:remove",
    "description": "Soft delete, из базы не удаляется, проставляется статус.Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=682907591.Метод доступен для: admin, manager, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/multiapp/api/v1/app",
    "title": "Метод сохранения приложения",
    "method": "post",
    "service": "multiapp",
    "module": "app",
    "resource": "app",
    "access": "save",
    "scope": "multiapp:app:save",
    "description": "Поддерживает создание и обновление.Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695668.Метод доступен для: admin, manager, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/notification_template/{id}",
    "title": "Метод получения шаблона уведомления",
    "method": "get",
    "service": "multiapp",
    "module": "notification_template",
    "resource": "notification_template",
    "access": "card",
    "scope": "multiapp:notification_template:card",
    "description": "Метод доступен для: admin, manager, service, partner.Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization.Роли partner доступны только связанные с ней шаблоны",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/notification_template/count",
    "title": "Метод получения количества шаблонов уведомлений",
    "method": "get",
    "service": "multiapp",
    "module": "notification_template",
    "resource": "notification_template",
    "access": "list",
    "scope": "multiapp:notification_template:list",
    "description": "Метод доступен для: admin, manager, service, partner.Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization.Если метод вызван ролью partner в фильтре поле partner_ids принудительно замещается его идентификатором",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/notification_template/list",
    "title": "Метод получения списка шаблонов уведомлений",
    "method": "get",
    "service": "multiapp",
    "module": "notification_template",
    "resource": "notification_template",
    "access": "list",
    "scope": "multiapp:notification_template:list",
    "description": "Метод доступен для: admin, manager, service, partner.Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization.Если метод вызван ролью partner в фильтре поле partner_ids принудительно замещается его идентификатором",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/multiapp/api/v1/notification_template/{notificationTemplatePartner.notificationTemplateId}/partner/{notificationTemplatePartner.partnerId}/attach",
    "title": "Метод создания связи шаблона уведомления и партнера",
    "method": "put",
    "service": "multiapp",
    "module": "notification_template",
    "resource": "partner",
    "access": "edit",
    "scope": "multiapp:notification_template:partner:edit",
    "description": "Метод доступен для: admin, manager, service",
    "params": [
      "notificationTemplatePartner.notificationTemplateId",
      "notificationTemplatePartner.partnerId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/multiapp/api/v1/notification_template/{notificationTemplatePartner.notificationTemplateId}/partner/{notificationTemplatePartner.partnerId}/detach",
    "title": "Метод удаления связи шаблона уведомления и партнера",
    "method": "put",
    "service": "multiapp",
    "module": "notification_template",
    "resource": "partner",
    "access": "edit",
    "scope": "multiapp:notification_template:partner:edit",
    "description": "Метод доступен для: admin, manager, service",
    "params": [
      "notificationTemplatePartner.notificationTemplateId",
      "notificationTemplatePartner.partnerId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/multiapp/api/v1/notification_template/{id}",
    "title": "Метод удаления шаблона уведомления",
    "method": "delete",
    "service": "multiapp",
    "module": "notification_template",
    "resource": "notification_template",
    "access": "remove",
    "scope": "multiapp:notification_template:remove",
    "description": "Устанавливает текущую дату и время в параметр deleted_at.Метод доступен для: admin, manager, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/multiapp/api/v1/notification_template",
    "title": "Метод сохранения шаблона уведомления",
    "method": "post",
    "service": "multiapp",
    "module": "notification_template",
    "resource": "notification_template",
    "access": "save",
    "scope": "multiapp:notification_template:save",
    "description": "Поддерживает создание и обновление.Поддерживает mustache теги в переменных template_header и template_text.Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=774989444.Метод доступен для: admin, manager, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/multiapp/api/v1/notification",
    "title": "Метод отправки уведомления уведомления",
    "method": "post",
    "service": "multiapp",
    "module": "notification",
    "resource": "notification",
    "access": "save",
    "scope": "multiapp:notification:save",
    "description": "Метод доступен для: partner.Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/partner/address/orpon/{orpon}",
    "title": "Метод получения адреса дома по ОРПОНу",
    "method": "get",
    "service": "multiapp",
    "module": "partner",
    "resource": "address",
    "access": "list",
    "scope": "multiapp:partner:address:list",
    "description": "Адресная строка должны быть в формате \"{Регион}, {Город}, {Улица}, {Дом}, {Строение}\".Партнер может получить адрес только по доступному ему ОРПОНу.Доступные ОРПОНы для партнера может получить через привязанные app в поле app_tags и user_tags.Метод доступен для: admin, manager, service, partner.Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization",
    "params": [
      "orpon"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/partner/{id}",
    "title": "Метод получения партнера",
    "method": "get",
    "service": "multiapp",
    "module": "partner",
    "resource": "partner",
    "access": "card",
    "scope": "multiapp:partner:card",
    "description": "Метод доступен для: admin, manager, service, ltp_first",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/partner/count",
    "title": "Метод получения количества партнеров",
    "method": "get",
    "service": "multiapp",
    "module": "partner",
    "resource": "partner",
    "access": "list",
    "scope": "multiapp:partner:list",
    "description": "Метод доступен для: admin, manager, service, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/partner/list",
    "title": "Метод получения списка партнеров",
    "method": "get",
    "service": "multiapp",
    "module": "partner",
    "resource": "partner",
    "access": "list",
    "scope": "multiapp:partner:list",
    "description": "Метод доступен для: admin, manager, service, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/multiapp/api/v1/partner/public_key",
    "title": "Метод обновления публичного ключа партнёра",
    "method": "post",
    "service": "multiapp",
    "module": "partner",
    "resource": "public_key",
    "access": "save",
    "scope": "multiapp:partner:public_key:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: partner.Требует передачи аутентификационного ключа в заголовке X-API-KEY.Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695525",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/multiapp/api/v1/partner/{id}",
    "title": "Метод удаления партнёра",
    "method": "delete",
    "service": "multiapp",
    "module": "partner",
    "resource": "partner",
    "access": "remove",
    "scope": "multiapp:partner:remove",
    "description": "Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=804302306.Метод доступен для: admin, manager, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/multiapp/api/v1/partner",
    "title": "Метод сохранения партнера",
    "method": "post",
    "service": "multiapp",
    "module": "partner",
    "resource": "partner",
    "access": "save",
    "scope": "multiapp:partner:save",
    "description": "Поддерживает создание и обновление.Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695525.Метод доступен для: admin, manager, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/partner/token",
    "title": "Метод получения токена",
    "method": "get",
    "service": "multiapp",
    "module": "partner",
    "resource": "token",
    "access": "list",
    "scope": "multiapp:partner:token:list",
    "description": "Access токен возможно получить только для пользователей с типом master в статусе active, demo и new.Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=664695865.Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/multiapp/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "multiapp",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "multiapp:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/notification/api/v1/push_token/count",
    "title": "Метод получения количества пуш-токенов",
    "method": "get",
    "service": "notification",
    "module": "push_token",
    "resource": "push_token",
    "access": "list",
    "scope": "notification:push_token:list",
    "description": "Метод доступен для: admin, master, employee, owner, service, application(notification:read или notification:edit).Для ролей master, employee, owner можно просматривать только собственные пуш-токены.Для ролей admin, service доступны все пуш-токены",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/notification/api/v1/push_token/list",
    "title": "Метод получения пуш-токенов",
    "method": "get",
    "service": "notification",
    "module": "push_token",
    "resource": "push_token",
    "access": "list",
    "scope": "notification:push_token:list",
    "description": "Метод доступен для: admin, master, employee, owner, service, application(notification:read или notification:edit).Для ролей master, employee, owner можно просматривать только собственные пуш-токены.Для ролей admin, service доступны все пуш-токены",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/notification/api/v1/push_token/user_app_id/{userAppId}",
    "title": "Метод удаления пуш-токена по идентификатору устройства пользователя",
    "method": "delete",
    "service": "notification",
    "module": "push_token",
    "resource": "push_token",
    "access": "remove",
    "scope": "notification:push_token:remove",
    "description": "Метод доступен для: admin, master, employee, owner, service, application(notification:edit).Для ролей master, employee, owner можно удалять только собственные пуш-токены.Для ролей admin, service можно удалять все пуш-токены",
    "params": [
      "userAppId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/notification/api/v1/push_token/user_id/{userId}",
    "title": "Метод удаления пуш-токенов по идентификатору пользователя",
    "method": "delete",
    "service": "notification",
    "module": "push_token",
    "resource": "push_token",
    "access": "remove",
    "scope": "notification:push_token:remove",
    "description": "Метод доступен для: admin, master, employee, owner, service, application(notification:edit).Для ролей master, employee, owner можно удалять только собственные пуш-токены.Для ролей admin, service можно удалять все пуш-токены",
    "params": [
      "userId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/notification/api/v1/push_token/{id}",
    "title": "Метод удаления пуш-токена",
    "method": "delete",
    "service": "notification",
    "module": "push_token",
    "resource": "push_token",
    "access": "remove",
    "scope": "notification:push_token:remove",
    "description": "Метод доступен для: admin, master, employee, owner, service, application(notification:edit).Для ролей master, employee, owner можно удалять только собственные пуш-токены.Для ролей admin, service можно удалять все пуш-токены",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/notification/api/v1/push_token",
    "title": "Метод сохранения пуш-токенов",
    "method": "post",
    "service": "notification",
    "module": "push_token",
    "resource": "push_token",
    "access": "save",
    "scope": "notification:push_token:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: admin, master, employee, owner, service, application(notification:edit).Для ролей master, employee, owner можно сохранять только собственные пуш-токены.Для ролей admin, service доступны все пуш-токены",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/notification/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "notification",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "notification:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/omnichat/api/v1/auth",
    "title": "Метод получения хешированной инормации о пользователе",
    "method": "get",
    "service": "omnichat",
    "module": "auth",
    "resource": "auth",
    "access": "list",
    "scope": "omnichat:auth:list",
    "description": "Метод доступен для: master, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/omnichat/api/v1/credentials",
    "title": "Метод получение реквизитов для авторизации в Omnichat",
    "method": "post",
    "service": "omnichat",
    "module": "credentials",
    "resource": "credentials",
    "access": "save",
    "scope": "omnichat:credentials:save",
    "description": "Метод доступен для: master, employee, owner",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/omnichat/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "omnichat",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "omnichat:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/preset/api/v1/preset/{id}",
    "title": "Метод получения пресета по идентификатору",
    "method": "get",
    "service": "preset",
    "module": "preset",
    "resource": "preset",
    "access": "card",
    "scope": "preset:card",
    "description": "Метод доступен для: admin, service, bti, ltp_first, owner, employee",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/preset/api/v1/preset/default",
    "title": "Метод получения дефолтного пресета",
    "method": "get",
    "service": "preset",
    "module": "preset",
    "resource": "default",
    "access": "list",
    "scope": "preset:default:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/preset/api/v1/preset/count",
    "title": "Метод получения количества пресетов",
    "method": "get",
    "service": "preset",
    "module": "preset",
    "resource": "preset",
    "access": "list",
    "scope": "preset:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/preset/api/v1/preset/list",
    "title": "Метод получения пресетов",
    "method": "get",
    "service": "preset",
    "module": "preset",
    "resource": "preset",
    "access": "list",
    "scope": "preset:list",
    "description": "Метод доступен для: admin, service, bti, ltp_first, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/preset/api/v1/preset/{id}",
    "title": "Метод удаления пресета",
    "method": "delete",
    "service": "preset",
    "module": "preset",
    "resource": "preset",
    "access": "remove",
    "scope": "preset:remove",
    "description": "Нельзя удалить пресет, если он используется на устройстве.Нельзя удалить дефолтный пресет.Метод доступен для: admin, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/preset/api/v1/preset",
    "title": "Метод сохранения пресетов",
    "method": "post",
    "service": "preset",
    "module": "preset",
    "resource": "preset",
    "access": "save",
    "scope": "preset:save",
    "description": "Поддерживает создание и обновление.При обновлении пресета посылается задача PresetInstallTask в очередь key.preset.install.Данное сообщение должно отправляться только если изменению подверглось одно из следующих полей:- Sip;- Ntp;- Syslog;- Room;- VideoConfig;- Dtmf.Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/preset/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "preset",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "preset:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/rfidregistry/api/v1/record/{id}",
    "title": "Метод получения записи",
    "method": "get",
    "service": "rfidregistry",
    "module": "record",
    "resource": "record",
    "access": "card",
    "scope": "rfidregistry:record:card",
    "description": "Метод доступен для: admin, service, device_admin",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/rfidregistry/api/v1/record/count",
    "title": "Метод получения количества записей",
    "method": "get",
    "service": "rfidregistry",
    "module": "record",
    "resource": "record",
    "access": "list",
    "scope": "rfidregistry:record:list",
    "description": "Метод доступен для: admin, service, device_admin",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/rfidregistry/api/v1/record/list",
    "title": "Метод получения списка записей",
    "method": "get",
    "service": "rfidregistry",
    "module": "record",
    "resource": "record",
    "access": "list",
    "scope": "rfidregistry:record:list",
    "description": "Метод доступен для: admin, service, device_admin",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/rfidregistry/api/v1/record/{id}",
    "title": "Метод удаления записи",
    "method": "delete",
    "service": "rfidregistry",
    "module": "record",
    "resource": "record",
    "access": "remove",
    "scope": "rfidregistry:record:remove",
    "description": "Можно удалять только свои записи.Нельзя удалить ключ, если его использует кто-то другой.Метод доступен для: admin, service, device_admin",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/rfidregistry/api/v1/record",
    "title": "Метод сохранения записи",
    "method": "post",
    "service": "rfidregistry",
    "module": "record",
    "resource": "record",
    "access": "save",
    "scope": "rfidregistry:record:save",
    "description": "Нельзя отвязать ключ, который привязал кто-то другой.Поддерживает создание и обновление.Метод доступен для: admin, service, device_admin",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/rfidregistry/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "rfidregistry",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "rfidregistry:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/subscription/api/v1/subscription/{id}",
    "title": "Метод получения подписки",
    "method": "get",
    "service": "subscription",
    "module": "subscription",
    "resource": "subscription",
    "access": "card",
    "scope": "subscription:card",
    "description": "Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/subscription/count",
    "title": "Метод получения количества подписок",
    "method": "get",
    "service": "subscription",
    "module": "subscription",
    "resource": "subscription",
    "access": "list",
    "scope": "subscription:list",
    "description": "Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/subscription/list",
    "title": "Метод получения списка подписок",
    "method": "get",
    "service": "subscription",
    "module": "subscription",
    "resource": "subscription",
    "access": "list",
    "scope": "subscription:list",
    "description": "Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/offer/{id}",
    "title": "Метод получения коммерческой возможности",
    "method": "get",
    "service": "subscription",
    "module": "offer",
    "resource": "offer",
    "access": "card",
    "scope": "subscription:offer:card",
    "description": "Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/offer/count",
    "title": "Метод получения количества коммерческих возможностей",
    "method": "get",
    "service": "subscription",
    "module": "offer",
    "resource": "offer",
    "access": "list",
    "scope": "subscription:offer:list",
    "description": "Метод доступен для: admin, mrf, master, external_seller, ltp_first, owner, employee, service, application(subscription:read или subscription:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/offer/list",
    "title": "Метод получения списка коммерческих возможностей",
    "method": "get",
    "service": "subscription",
    "module": "offer",
    "resource": "offer",
    "access": "list",
    "scope": "subscription:offer:list",
    "description": "Метод доступен для: admin, mrf, master, external_seller, ltp_first, owner, employee, service, application(subscription:read или subscription:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/plan/{id}",
    "title": "Метод получения технологического плана",
    "method": "get",
    "service": "subscription",
    "module": "plan",
    "resource": "plan",
    "access": "card",
    "scope": "subscription:plan:card",
    "description": "Метод доступен для: admin, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/plan/count",
    "title": "Метод получения количества технологических планов",
    "method": "get",
    "service": "subscription",
    "module": "plan",
    "resource": "plan",
    "access": "list",
    "scope": "subscription:plan:list",
    "description": "Метод доступен для: admin, service, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/plan/list",
    "title": "Метод получения списка технологических планов",
    "method": "get",
    "service": "subscription",
    "module": "plan",
    "resource": "plan",
    "access": "list",
    "scope": "subscription:plan:list",
    "description": "Метод доступен для: admin, service, mrf, master, ltp_first, service, application(subscription:read или subscription:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/privilege/check/{orpon}/{flatNumber}/{privilegeType}",
    "title": "Метод проверки привилегии",
    "method": "get",
    "service": "subscription",
    "module": "privilege",
    "resource": "check",
    "access": "list",
    "scope": "subscription:privilege:check:list",
    "description": "Метод доступен для: admin, master, service, ltp_first, application(subscription:read или subscription:edit)",
    "params": [
      "orpon",
      "flatNumber",
      "privilegeType"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/privilege/count",
    "title": "Метод получения количества привилегий",
    "method": "get",
    "service": "subscription",
    "module": "privilege",
    "resource": "privilege",
    "access": "list",
    "scope": "subscription:privilege:list",
    "description": "Метод доступен для: admin, master, service, ltp_first, application(subscription:read или subscription:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/privilege/list",
    "title": "Метод получения привилегий",
    "method": "get",
    "service": "subscription",
    "module": "privilege",
    "resource": "privilege",
    "access": "list",
    "scope": "subscription:privilege:list",
    "description": "Метод доступен для: admin, master, service, ltp_first, application(subscription:read или subscription:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/service/kind/list",
    "title": "Метод получения справочника видов услуг",
    "method": "get",
    "service": "subscription",
    "module": "service",
    "resource": "kind",
    "access": "list",
    "scope": "subscription:service:kind:list",
    "description": "Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/service/{orpon}/{flatNumber}/list",
    "title": "Метод получения услуг квартиры",
    "method": "get",
    "service": "subscription",
    "module": "service",
    "resource": "service",
    "access": "list",
    "scope": "subscription:service:list",
    "description": "Вернёт все услуги на квартире и недоступные по адресу как неактивные.Метод доступен для: admin, master, service, application(subscription:read или subscription:edit)",
    "params": [
      "orpon",
      "flatNumber"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/service/privilege/count",
    "title": "Метод получения количества услуг",
    "method": "get",
    "service": "subscription",
    "module": "service",
    "resource": "privilege",
    "access": "list",
    "scope": "subscription:service:privilege:list",
    "description": "Вернёт все услуги на квартире и недоступные по адресу как неактивные.Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/service/privilege/list",
    "title": "Метод получения списка услуг",
    "method": "get",
    "service": "subscription",
    "module": "service",
    "resource": "privilege",
    "access": "list",
    "scope": "subscription:service:privilege:list",
    "description": "Вернёт все услуги на квартире и недоступные по адресу как неактивные.Метод доступен для: admin, service",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/subscription/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "subscription",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "subscription:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/tag/api/v1/tag/list",
    "title": "Метод получения списка тэгов",
    "method": "get",
    "service": "tag",
    "module": "tag",
    "resource": "tag",
    "access": "list",
    "scope": "tag:list",
    "description": "Метод доступен для: master, slave",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/tag/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "tag",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "tag:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/telemetry_alerting/api/v1/system/status",
    "title": "Метод проверки доступности по порту из интернета",
    "method": "get",
    "service": "telemetry_alerting",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "telemetry_alerting:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/telemetry_alerting/api/v1/trigger/alert/{id}/device/list",
    "title": "Список устройств, вызвавших появление алерта",
    "method": "get",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "alert:device",
    "access": "list",
    "scope": "telemetry_alerting:trigger:alert:device:list",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_alerting/api/v1/trigger/alert/{id}/disable",
    "title": "Принудительное выключение алерта",
    "method": "post",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "alert:disable",
    "access": "save",
    "scope": "telemetry_alerting:trigger:alert:disable:save",
    "description": "Дата closed_at проставляется текущим временем.Флаг is_disabled проставляется true.Флаг is_manually_closed проставляется true.Можно принудительно выключать только алерты созданные по триггерам с атрибутом manually_unclosable=false.Метод доступен для: service, application(telemetry:edit)",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_alerting/api/v1/trigger/alert/count",
    "title": "Метод получения количества алертов",
    "method": "get",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "alert",
    "access": "list",
    "scope": "telemetry_alerting:trigger:alert:list",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_alerting/api/v1/trigger/alert/list",
    "title": "Метод получения списка алертов",
    "method": "get",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "alert",
    "access": "list",
    "scope": "telemetry_alerting:trigger:alert:list",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/telemetry_alerting/api/v1/trigger/alert/{id}",
    "title": "Удаление алерта",
    "method": "delete",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "alert",
    "access": "remove",
    "scope": "telemetry_alerting:trigger:alert:remove",
    "description": "Метод удаляет только погашенный алерт (is_disabled=true).Удаление непогашенного вызовет ошибку.Метод доступен для: service, application(telemetry:edit)",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_alerting/api/v1/trigger/{id}",
    "title": "Чтение одного триггера",
    "method": "get",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "trigger",
    "access": "card",
    "scope": "telemetry_alerting:trigger:card",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_alerting/api/v1/trigger/count",
    "title": "Метод получения количества триггеров",
    "method": "get",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "trigger",
    "access": "list",
    "scope": "telemetry_alerting:trigger:list",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_alerting/api/v1/trigger/list",
    "title": "Метод получения списка триггеров",
    "method": "get",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "trigger",
    "access": "list",
    "scope": "telemetry_alerting:trigger:list",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/telemetry_alerting/api/v1/trigger/{id}",
    "title": "Удаление триггера",
    "method": "delete",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "trigger",
    "access": "remove",
    "scope": "telemetry_alerting:trigger:remove",
    "description": "Метод удаляет только отключенный триггер (is_disabled=true).Удаление неотключенного вызовет ошибку.При удалении триггера удаляются и все его алерты.Метод доступен для: service, application(telemetry:edit)",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_alerting/api/v1/trigger",
    "title": "Метод сохранения триггера",
    "method": "post",
    "service": "telemetry_alerting",
    "module": "trigger",
    "resource": "trigger",
    "access": "save",
    "scope": "telemetry_alerting:trigger:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: service, application(telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/building/{id}",
    "title": "Метод получения объекта строительства",
    "method": "get",
    "service": "telemetry_control",
    "module": "building",
    "resource": "building",
    "access": "card",
    "scope": "telemetry_control:building:card",
    "description": "Разрешения: telemetry_control:building:card, telemetry_control:building:card:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений.Метод доступен для: ApiKey: При наличии разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/telemetry_control/api/v1/building/{buildingGroup.buildingId}/group/{buildingGroup.groupId}/attach",
    "title": "Метод сохранения связей объектов строительства и группы пользователя",
    "method": "put",
    "service": "telemetry_control",
    "module": "building",
    "resource": "group",
    "access": "edit",
    "scope": "telemetry_control:building:group:edit",
    "description": "Поддерживает только создание.Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений",
    "params": [
      "buildingGroup.buildingId",
      "buildingGroup.groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/telemetry_control/api/v1/building/{buildingGroup.buildingId}/group/{buildingGroup.groupId}/detach",
    "title": "Метод удаления связей объектов строительства и группы пользователя",
    "method": "put",
    "service": "telemetry_control",
    "module": "building",
    "resource": "group",
    "access": "edit",
    "scope": "telemetry_control:building:group:edit",
    "description": "Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений",
    "params": [
      "buildingGroup.buildingId",
      "buildingGroup.groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/building/group/count",
    "title": "Метод получения количества связей объектов строительства и группы пользователя",
    "method": "get",
    "service": "telemetry_control",
    "module": "building",
    "resource": "group",
    "access": "list",
    "scope": "telemetry_control:building:group:list",
    "description": "Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/building/group/list",
    "title": "Метод получения списка связей объектов строительства и группы пользователя",
    "method": "get",
    "service": "telemetry_control",
    "module": "building",
    "resource": "group",
    "access": "list",
    "scope": "telemetry_control:building:group:list",
    "description": "Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/building/count",
    "title": "Метод получения количества объектов строительства",
    "method": "get",
    "service": "telemetry_control",
    "module": "building",
    "resource": "building",
    "access": "list",
    "scope": "telemetry_control:building:list",
    "description": "Разрешения: telemetry_control:building:list, telemetry_control:building:list:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений.Метод доступен для: ApiKey: При наличии разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/building/list",
    "title": "Метод получения списка объектов строительства",
    "method": "get",
    "service": "telemetry_control",
    "module": "building",
    "resource": "building",
    "access": "list",
    "scope": "telemetry_control:building:list",
    "description": "Разрешения: telemetry_control:building:list, telemetry_control:building:list:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений.Метод доступен для: ApiKey: При наличии разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/telemetry_control/api/v1/building/{id}",
    "title": "Метод удаления объекта строительства",
    "method": "delete",
    "service": "telemetry_control",
    "module": "building",
    "resource": "building",
    "access": "remove",
    "scope": "telemetry_control:building:remove",
    "description": "Разрешения: telemetry_control:building:remove, telemetry_control:building:remove:own.Метод доступен для: admin, service, bti, seller, application, owner, employee. При наличии разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_control/api/v1/building",
    "title": "Метод сохранения объекта строительства",
    "method": "post",
    "service": "telemetry_control",
    "module": "building",
    "resource": "building",
    "access": "save",
    "scope": "telemetry_control:building:save",
    "description": "Поддерживает создание и обновление.Разрешения: telemetry_control:building:save, telemetry_control:building:save:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/{id}",
    "title": "Метод получения ПУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "device",
    "access": "card",
    "scope": "telemetry_control:device:card",
    "description": "Разрешения: telemetry_control:device:card, telemetry_control:device:card:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee, master. При наличии разрешений.Метод доступен для: ApiKey: При наличии разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/telemetry_control/api/v1/device/{deviceGroup.deviceId}/group/{deviceGroup.groupId}/attach",
    "title": "Метод сохранения связей ПУ и группы пользователя",
    "method": "put",
    "service": "telemetry_control",
    "module": "device",
    "resource": "group",
    "access": "edit",
    "scope": "telemetry_control:device:group:edit",
    "description": "Поддерживает только создание.Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений",
    "params": [
      "deviceGroup.deviceId",
      "deviceGroup.groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/telemetry_control/api/v1/device/{deviceGroup.deviceId}/group/{deviceGroup.groupId}/detach",
    "title": "Метод удаления связей ПУ и группы пользователя",
    "method": "put",
    "service": "telemetry_control",
    "module": "device",
    "resource": "group",
    "access": "edit",
    "scope": "telemetry_control:device:group:edit",
    "description": "Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений",
    "params": [
      "deviceGroup.deviceId",
      "deviceGroup.groupId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/group/count",
    "title": "Метод получения количества связей ПУ и группы пользователя",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "group",
    "access": "list",
    "scope": "telemetry_control:device:group:list",
    "description": "Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/group/list",
    "title": "Метод получения списка связей ПУ и группы пользователя",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "group",
    "access": "list",
    "scope": "telemetry_control:device:group:list",
    "description": "Метод доступен для: Token: admin, service, bti, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/indicator/{id}",
    "title": "Метод получения индикатора",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "indicator",
    "access": "card",
    "scope": "telemetry_control:device:indicator:card",
    "description": "Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/indicator/count",
    "title": "Метод получения количества индикаторов",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "indicator",
    "access": "list",
    "scope": "telemetry_control:device:indicator:list",
    "description": "Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/indicator/list",
    "title": "Метод получения списка индикаторов",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "indicator",
    "access": "list",
    "scope": "telemetry_control:device:indicator:list",
    "description": "Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/telemetry_control/api/v1/device/indicator/{deviceIndicatorMetricPoint.indicatorId}/metric_point/{deviceIndicatorMetricPoint.metricPointId}/attach",
    "title": "Метод сохранения связи индикаторов и ТУ",
    "method": "put",
    "service": "telemetry_control",
    "module": "device",
    "resource": "indicator:metric_point",
    "access": "edit",
    "scope": "telemetry_control:device:indicator:metric_point:edit",
    "description": "Поддерживает только создание связи.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [
      "deviceIndicatorMetricPoint.indicatorId",
      "deviceIndicatorMetricPoint.metricPointId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/telemetry_control/api/v1/device/indicator/{deviceIndicatorMetricPoint.indicatorId}/metric_point/{deviceIndicatorMetricPoint.metricPointId}/detach",
    "title": "Метод удаления связи индикаторов и ТУ",
    "method": "put",
    "service": "telemetry_control",
    "module": "device",
    "resource": "indicator:metric_point",
    "access": "edit",
    "scope": "telemetry_control:device:indicator:metric_point:edit",
    "description": "Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [
      "deviceIndicatorMetricPoint.indicatorId",
      "deviceIndicatorMetricPoint.metricPointId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/indicator/metric_point/count",
    "title": "Метод получения количества связей индикаторов и ТУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "indicator:metric_point",
    "access": "list",
    "scope": "telemetry_control:device:indicator:metric_point:list",
    "description": "Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/indicator/metric_point/list",
    "title": "Метод получения списка связей индикаторов и ТУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "indicator:metric_point",
    "access": "list",
    "scope": "telemetry_control:device:indicator:metric_point:list",
    "description": "Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/telemetry_control/api/v1/device/indicator/{id}",
    "title": "Метод удаления индикаторa",
    "method": "delete",
    "service": "telemetry_control",
    "module": "device",
    "resource": "indicator",
    "access": "remove",
    "scope": "telemetry_control:device:indicator:remove",
    "description": "Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_control/api/v1/device/indicator",
    "title": "Метод сохранения индикатора",
    "method": "post",
    "service": "telemetry_control",
    "module": "device",
    "resource": "indicator",
    "access": "save",
    "scope": "telemetry_control:device:indicator:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/count",
    "title": "Метод получения количества приборов учета",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "device",
    "access": "list",
    "scope": "telemetry_control:device:list",
    "description": "Разрешения: telemetry_control:device:list, telemetry_control:device:list:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee, master. При наличии разрешений.Метод доступен для: ApiKey: При наличии разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/device/list",
    "title": "Метод получения списка приборов учета",
    "method": "get",
    "service": "telemetry_control",
    "module": "device",
    "resource": "device",
    "access": "list",
    "scope": "telemetry_control:device:list",
    "description": "Разрешения: telemetry_control:device:list, telemetry_control:device:list:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee, master. При наличии разрешений.Метод доступен для: ApiKey: При наличии разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/telemetry_control/api/v1/device/{id}",
    "title": "Метод удаления прибора учета",
    "method": "delete",
    "service": "telemetry_control",
    "module": "device",
    "resource": "device",
    "access": "remove",
    "scope": "telemetry_control:device:remove",
    "description": "Разрешения: telemetry_control:device:remove, telemetry_control:device:remove:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_control/api/v1/device/replace",
    "title": "Метод замены прибора учета",
    "method": "post",
    "service": "telemetry_control",
    "module": "device",
    "resource": "replace",
    "access": "save",
    "scope": "telemetry_control:device:replace:save",
    "description": "Создает ПУ и привязывает его индикаторы к ТУ исходного ПУ.Разрешения: telemetry_control:device:save, telemetry_control:device:save:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_control/api/v1/device",
    "title": "Метод сохранения прибора учета",
    "method": "post",
    "service": "telemetry_control",
    "module": "device",
    "resource": "device",
    "access": "save",
    "scope": "telemetry_control:device:save",
    "description": "Поддерживает создание и обновление.Разрешения: telemetry_control:device:save, telemetry_control:device:save:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. При наличии разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/dictionary/device_model/count",
    "title": "Метод получения количества моделей ПУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "dictionary",
    "resource": "device_model",
    "access": "list",
    "scope": "telemetry_control:dictionary:device_model:list",
    "description": "Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/dictionary/device_model/list",
    "title": "Метод получения списка моделей ПУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "dictionary",
    "resource": "device_model",
    "access": "list",
    "scope": "telemetry_control:dictionary:device_model:list",
    "description": "Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/telemetry_control/api/v1/dictionary/device_model/{id}",
    "title": "Метод удаления модели ПУ",
    "method": "delete",
    "service": "telemetry_control",
    "module": "dictionary",
    "resource": "device_model",
    "access": "remove",
    "scope": "telemetry_control:dictionary:device_model:remove",
    "description": "Метод доступен для: Token: admin, service, application. Без учета разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_control/api/v1/dictionary/device_model",
    "title": "Метод сохранения модели ПУ",
    "method": "post",
    "service": "telemetry_control",
    "module": "dictionary",
    "resource": "device_model",
    "access": "save",
    "scope": "telemetry_control:dictionary:device_model:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: Token: admin, service, application. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/dictionary/mrf/count",
    "title": "Метод получения количества элементов справочника Макрорегионы (МРФ)",
    "method": "get",
    "service": "telemetry_control",
    "module": "dictionary",
    "resource": "mrf",
    "access": "list",
    "scope": "telemetry_control:dictionary:mrf:list",
    "description": "Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/dictionary/mrf/list",
    "title": "Метод получения списка элементов справочника Макрорегионы (МРФ)",
    "method": "get",
    "service": "telemetry_control",
    "module": "dictionary",
    "resource": "mrf",
    "access": "list",
    "scope": "telemetry_control:dictionary:mrf:list",
    "description": "Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/dictionary/rf/count",
    "title": "Метод получения количества элементов справочника Регионы (РФ)",
    "method": "get",
    "service": "telemetry_control",
    "module": "dictionary",
    "resource": "rf",
    "access": "list",
    "scope": "telemetry_control:dictionary:rf:list",
    "description": "Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/dictionary/rf/list",
    "title": "Метод получения списка элементов справочника Регионы (РФ)",
    "method": "get",
    "service": "telemetry_control",
    "module": "dictionary",
    "resource": "rf",
    "access": "list",
    "scope": "telemetry_control:dictionary:rf:list",
    "description": "Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/metric_point/{id}",
    "title": "Метод получения ТУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "metric_point",
    "resource": "metric_point",
    "access": "card",
    "scope": "telemetry_control:metric_point:card",
    "description": "Разрешения: telemetry_control:metric_point:card, telemetry_control:metric_point:card:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений.Метод доступен для: ApiKey: При наличии разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/metric_point/count",
    "title": "Метод получения количества ТУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "metric_point",
    "resource": "metric_point",
    "access": "list",
    "scope": "telemetry_control:metric_point:list",
    "description": "Разрешения: telemetry_control:metric_point:list, telemetry_control:metric_point:list:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений.Метод доступен для: ApiKey: При наличии разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/metric_point/list",
    "title": "Метод получения списка ТУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "metric_point",
    "resource": "metric_point",
    "access": "list",
    "scope": "telemetry_control:metric_point:list",
    "description": "Разрешения: telemetry_control:metric_point:list, telemetry_control:metric_point:list:own.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений.Метод доступен для: ApiKey: При наличии разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/telemetry_control/api/v1/metric_point/{id}",
    "title": "Метод удаления ТУ",
    "method": "delete",
    "service": "telemetry_control",
    "module": "metric_point",
    "resource": "metric_point",
    "access": "remove",
    "scope": "telemetry_control:metric_point:remove",
    "description": "Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_control/api/v1/metric_point",
    "title": "Метод сохранения ТУ",
    "method": "post",
    "service": "telemetry_control",
    "module": "metric_point",
    "resource": "metric_point",
    "access": "save",
    "scope": "telemetry_control:metric_point:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/system/status",
    "title": "Метод проверки доступности по порту из интернета",
    "method": "get",
    "service": "telemetry_control",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "telemetry_control:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/telemetry_control/api/v1/template/device/{id}",
    "title": "Метод получения шаблона ПУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "template",
    "resource": "device",
    "access": "card",
    "scope": "telemetry_control:template:device:card",
    "description": "Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/template/device/count",
    "title": "Метод получения количества шаблонов ПУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "template",
    "resource": "device",
    "access": "list",
    "scope": "telemetry_control:template:device:list",
    "description": "Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/template/device/list",
    "title": "Метод получения списка шаблонов ПУ",
    "method": "get",
    "service": "telemetry_control",
    "module": "template",
    "resource": "device",
    "access": "list",
    "scope": "telemetry_control:template:device:list",
    "description": "Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/telemetry_control/api/v1/template/device/{id}",
    "title": "Метод удаления шаблона ПУ",
    "method": "delete",
    "service": "telemetry_control",
    "module": "template",
    "resource": "device",
    "access": "remove",
    "scope": "telemetry_control:template:device:remove",
    "description": "Метод доступен для: Token: admin, service, application. Без учета разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_control/api/v1/template/device",
    "title": "Метод сохранения шаблона ПУ",
    "method": "post",
    "service": "telemetry_control",
    "module": "template",
    "resource": "device",
    "access": "save",
    "scope": "telemetry_control:template:device:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: Token: admin, service, application. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/template/indicator/{id}",
    "title": "Метод получения шаблона индикатора",
    "method": "get",
    "service": "telemetry_control",
    "module": "template",
    "resource": "indicator",
    "access": "card",
    "scope": "telemetry_control:template:indicator:card",
    "description": "Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/template/indicator/count",
    "title": "Метод получения количества шаблонов индикаторов",
    "method": "get",
    "service": "telemetry_control",
    "module": "template",
    "resource": "indicator",
    "access": "list",
    "scope": "telemetry_control:template:indicator:list",
    "description": "Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_control/api/v1/template/indicator/list",
    "title": "Метод получения списка шаблонов индикаторов",
    "method": "get",
    "service": "telemetry_control",
    "module": "template",
    "resource": "indicator",
    "access": "list",
    "scope": "telemetry_control:template:indicator:list",
    "description": "Метод доступен для: Token: service, application, admin, owner, employee, bti, seller. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/telemetry_control/api/v1/template/indicator/{id}",
    "title": "Метод удаления шаблона шаблона индикатора",
    "method": "delete",
    "service": "telemetry_control",
    "module": "template",
    "resource": "indicator",
    "access": "remove",
    "scope": "telemetry_control:template:indicator:remove",
    "description": "Метод доступен для: Token: admin, service, application. Без учета разрешений",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_control/api/v1/template/indicator",
    "title": "Метод сохранения шаблонов индикатора",
    "method": "post",
    "service": "telemetry_control",
    "module": "template",
    "resource": "indicator",
    "access": "save",
    "scope": "telemetry_control:template:indicator:save",
    "description": "Поддерживает создание и обновление.Метод доступен для: Token: admin, service, application. Без учета разрешений",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_metric/api/v1/measurement/converted/count",
    "title": "Метод получения количества преобразованных измерений",
    "method": "get",
    "service": "telemetry_metric",
    "module": "measurement",
    "resource": "converted",
    "access": "list",
    "scope": "telemetry_metric:measurement:converted:list",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_metric/api/v1/measurement/converted/list",
    "title": "Метод получения списка преобразованных измерений",
    "method": "get",
    "service": "telemetry_metric",
    "module": "measurement",
    "resource": "converted",
    "access": "list",
    "scope": "telemetry_metric:measurement:converted:list",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_metric/api/v1/measurement/count",
    "title": "Метод получения количества измерений",
    "method": "get",
    "service": "telemetry_metric",
    "module": "measurement",
    "resource": "measurement",
    "access": "list",
    "scope": "telemetry_metric:measurement:list",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_metric/api/v1/measurement/list",
    "title": "Метод получения списка измерений",
    "method": "get",
    "service": "telemetry_metric",
    "module": "measurement",
    "resource": "measurement",
    "access": "list",
    "scope": "telemetry_metric:measurement:list",
    "description": "Метод доступен для: service, application(telemetry:read или telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/telemetry_metric/api/v1/measurement",
    "title": "Метод сохранения измерений",
    "method": "post",
    "service": "telemetry_metric",
    "module": "measurement",
    "resource": "measurement",
    "access": "save",
    "scope": "telemetry_metric:measurement:save",
    "description": "Метод доступен для: service, application(telemetry:edit)",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_metric/api/v1/system/status",
    "title": "Метод проверки доступности по порту из интернета",
    "method": "get",
    "service": "telemetry_metric",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "telemetry_metric:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/telemetry_status/api/v1/device_status/count",
    "title": "Метод получения количества статусов доступности устройств",
    "method": "get",
    "service": "telemetry_status",
    "module": "device_status",
    "resource": "device_status",
    "access": "list",
    "scope": "telemetry_status:device_status:list",
    "description": "Метод доступен для: Token: service, admin. Без учета разрешений.Метод доступен для: ApiKey: Разрешения: telemetry_status:device_status:list",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_status/api/v1/device_status/list",
    "title": "Метод получения списка статусов доступности устройств",
    "method": "get",
    "service": "telemetry_status",
    "module": "device_status",
    "resource": "device_status",
    "access": "list",
    "scope": "telemetry_status:device_status:list",
    "description": "Метод доступен для: Token: service, admin. Без учета разрешений.Метод доступен для: ApiKey: Разрешения: telemetry_status:device_status:list",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/telemetry_status/api/v1/system/status",
    "title": "Метод проверки доступности по порту из интернета",
    "method": "get",
    "service": "telemetry_status",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "telemetry_status:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/user/api/v1/user/{id}",
    "title": "Метод получения пользователей",
    "method": "get",
    "service": "user",
    "module": "user",
    "resource": "user",
    "access": "card",
    "scope": "user:card",
    "description": "Метод доступен для: admin, service, manager, bti, ltp_first, owner, empolyee.Роли owner или employee могут запрашивать только пользователей, принадлежащих их компании",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/user/api/v1/user/code/create",
    "title": "Метод создания идентификационного кода пользователя",
    "method": "post",
    "service": "user",
    "module": "user",
    "resource": "code:create",
    "access": "save",
    "scope": "user:code:create:save",
    "description": "После создания кода отправляется событие SendingSmsTask.Метод доступен для: admin, service, ltp_first",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/user/api/v1/user/{id}/code",
    "title": "Метод получения идентификационного кода пользователя",
    "method": "get",
    "service": "user",
    "module": "user",
    "resource": "code",
    "access": "list",
    "scope": "user:code:list",
    "description": "Метод доступен для: admin, service, ltp_first",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/user/api/v1/user/count",
    "title": "Метод получения количества пользователей",
    "method": "get",
    "service": "user",
    "module": "user",
    "resource": "user",
    "access": "list",
    "scope": "user:list",
    "description": "Метод доступен для: admin, service, manager, bti, ltp_first, owner, empolyee.Если метод вызван ролями owner или employee в фильтре поле company_ids принудительно замещается их company_id",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/user/api/v1/user/list",
    "title": "Метод получения списка пользователей",
    "method": "get",
    "service": "user",
    "module": "user",
    "resource": "user",
    "access": "list",
    "scope": "user:list",
    "description": "Метод доступен для: admin, service, manager, bti, ltp_first, owner, empolyee.Если метод вызван ролями owner или employee в фильтре поле company_ids принудительно замещается их company_id",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/user/api/v1/user/{id}",
    "title": "Метод удаления пользователей",
    "method": "delete",
    "service": "user",
    "module": "user",
    "resource": "user",
    "access": "remove",
    "scope": "user:remove",
    "description": "Метод доступен для: admin, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/user/api/v1/user",
    "title": "Метод создания пользователя",
    "method": "post",
    "service": "user",
    "module": "user",
    "resource": "user",
    "access": "save",
    "scope": "user:save",
    "description": "Метод доступен для: admin, service.Доступно создание пользователей с типом: ADMIN, MRF, BTI, LTP_FIRST, SERVICE, DEVICE_ADMIN, MANAGER",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/user/api/v1/user/{id}/sessions",
    "title": "Метод удаления всех пользовательских сессий",
    "method": "delete",
    "service": "user",
    "module": "user",
    "resource": "sessions",
    "access": "remove",
    "scope": "user:sessions:remove",
    "description": "Метод доступен для: admin, service",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/user/api/v1/system/status",
    "title": "Метод получения статуса сервиса",
    "method": "get",
    "service": "user",
    "module": "system",
    "resource": "status",
    "access": "card",
    "scope": "user:system:status:card",
    "description": "Не требует авторизации",
    "params": [],
    "security": "allow anonymous",
    "visibility": "public",
    "specific": "system"
  },
  {
    "name": "get:/vc/api/v1/camera_collection/{id}",
    "title": "Метод получения коллекции камер",
    "method": "get",
    "service": "vc",
    "module": "camera_collection",
    "resource": "camera_collection",
    "access": "card",
    "scope": "vc:camera_collection:card",
    "description": "Для owner, employee возвращаются только коллекции камер c COMPANY_ID из токена.Метод доступен для: admin, service, bti, owner, employee",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera_collection/count",
    "title": "Метод получения количества коллекций камер",
    "method": "get",
    "service": "vc",
    "module": "camera_collection",
    "resource": "camera_collection",
    "access": "list",
    "scope": "vc:camera_collection:list",
    "description": "Для owner, employee возвращаются только коллекции камер c COMPANY_ID из токена.Метод доступен для: admin, service, bti, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera_collection/list",
    "title": "Метод получения списка коллекций камер",
    "method": "get",
    "service": "vc",
    "module": "camera_collection",
    "resource": "camera_collection",
    "access": "list",
    "scope": "vc:camera_collection:list",
    "description": "Для owner, employee возвращаются только коллекции камер c COMPANY_ID из токена.Метод доступен для: admin, service, bti, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/vc/api/v1/camera_collection/{id}",
    "title": "Метод удаления коллекции камер",
    "method": "delete",
    "service": "vc",
    "module": "camera_collection",
    "resource": "camera_collection",
    "access": "remove",
    "scope": "vc:camera_collection:remove",
    "description": "Проставляет в поле deleted_at текущую дату.Для owner, employee сравнивается COMPANY_ID из токена и company_id коллекции, при несовпадении ошибка доступа.Метод доступен для: admin, service, bti, owner, employee",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/vc/api/v1/camera_collection/restore/{id}",
    "title": "Метод восстановления удаленной коллекции камер",
    "method": "post",
    "service": "vc",
    "module": "camera_collection",
    "resource": "restore",
    "access": "save",
    "scope": "vc:camera_collection:restore:save",
    "description": "Проставляет null в поле deleted_at.Для owner, employee сравнивается COMPANY_ID из токена и company_id коллекции, при несовпадении ошибка доступа.Метод доступен для: admin, service, bti, owner, employee",
    "params": [
      "id"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/vc/api/v1/camera_collection",
    "title": "Метод создания и изменения коллекции камер",
    "method": "post",
    "service": "vc",
    "module": "camera_collection",
    "resource": "camera_collection",
    "access": "save",
    "scope": "vc:camera_collection:save",
    "description": "При изменении коллекции массив external_camera_ids заменяется полностью.Для owner, employee сравнивается COMPANY_ID из токена и company_id коллекции, при несовпадении ошибка доступа.Метод доступен для: admin, service, bti, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera_location_data/{uid}",
    "title": "Метод получения данных o местонахождении камеры",
    "method": "get",
    "service": "vc",
    "module": "camera_location_data",
    "resource": "camera_location_data",
    "access": "list",
    "scope": "vc:camera_location_data:list",
    "description": "Метод доступен для: ApiKey",
    "params": [
      "uid"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera_video_data/count",
    "title": "Метод получения количества камер",
    "method": "get",
    "service": "vc",
    "module": "camera_video_data",
    "resource": "camera_video_data",
    "access": "list",
    "scope": "vc:camera_video_data:list",
    "description": "Для master это камеры, привязанные к пользователю, используем поля токена vc_user_id, user_id, company_id.Для owner, employee это камеры, привязанные к компании, используем поле токена company_id.Для admin, service, bti, ltp_first это камеры, привязанные к компании, используем поле scope.company_id.Для admin, service, bti, ltp_first это камеры, привязанные к пользователю, используем поле scope.user_id.Метод доступен для: admin, service, bti, ltp_first, master, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera_video_data/list",
    "title": "Метод получения списка камер",
    "method": "get",
    "service": "vc",
    "module": "camera_video_data",
    "resource": "camera_video_data",
    "access": "list",
    "scope": "vc:camera_video_data:list",
    "description": "Для master это камеры, привязанные к пользователю, используем поля токена vc_user_id, user_id, company_id.Для owner, employee это камеры, привязанные к компании, используем поле токена company_id.Для admin, service, bti, ltp_first это камеры, привязанные к компании, используем поле scope.company_id.Для admin, service, bti, ltp_first это камеры, привязанные к пользователю, используем поле scope.user_id.Метод доступен для: admin, service, bti, ltp_first, master, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera/list",
    "title": "Метод получения списка камер",
    "method": "get",
    "service": "vc",
    "module": "camera",
    "resource": "camera",
    "access": "list",
    "scope": "vc:camera:list",
    "description": "Для owner, employee параметр scope.vc_company_id подставляется из токена.Метод доступен для: admin, service, bti, ltp_first, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera/{uid}",
    "title": "Метод получения камеры",
    "method": "get",
    "service": "vc",
    "module": "camera",
    "resource": "camera",
    "access": "list",
    "scope": "vc:camera:list",
    "description": "Для owner, employee параметр scope.vc_company_id подставляется из токена.Метод доступен для: admin, service, bti, ltp_first, owner, employee",
    "params": [
      "uid"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "delete:/vc/api/v1/camera/{uid}",
    "title": "Метод удаления камеры",
    "method": "delete",
    "service": "vc",
    "module": "camera",
    "resource": "camera",
    "access": "remove",
    "scope": "vc:camera:remove",
    "description": "Метод доступен для: admin, service, bti",
    "params": [
      "uid"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/vc/api/v1/camera/room/attach/list",
    "title": "Метод пакетной привязки камер и квартир",
    "method": "put",
    "service": "vc",
    "module": "camera",
    "resource": "room",
    "access": "edit",
    "scope": "vc:camera:room:edit",
    "description": "Метод доступен для: admin, service, bti, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/vc/api/v1/camera/room/detach/list",
    "title": "Метод пакетной отвязки камер и квартир",
    "method": "put",
    "service": "vc",
    "module": "camera",
    "resource": "room",
    "access": "edit",
    "scope": "vc:camera:room:edit",
    "description": "Метод доступен для: admin, service, bti, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/vc/api/v1/camera/{data.cameraUid}/room/{data.orpon}/{data.roomNumber}/attach",
    "title": "Метод привязки камеры и квартиры",
    "method": "put",
    "service": "vc",
    "module": "camera",
    "resource": "room",
    "access": "edit",
    "scope": "vc:camera:room:edit",
    "description": "Метод доступен для: admin, service, bti, owner, employee",
    "params": [
      "data.cameraUid",
      "data.orpon",
      "data.roomNumber"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "put:/vc/api/v1/camera/{data.cameraUid}/room/{data.orpon}/{data.roomNumber}/detach",
    "title": "Метод отвязки камеры и квартиры",
    "method": "put",
    "service": "vc",
    "module": "camera",
    "resource": "room",
    "access": "edit",
    "scope": "vc:camera:room:edit",
    "description": "Метод доступен для: admin, service, bti, owner, employee",
    "params": [
      "data.cameraUid",
      "data.orpon",
      "data.roomNumber"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera/room/count",
    "title": "Метод получения количества связей камеры и квартиры",
    "method": "get",
    "service": "vc",
    "module": "camera",
    "resource": "room",
    "access": "list",
    "scope": "vc:camera:room:list",
    "description": "Метод доступен для: admin, service, bti, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera/room/list",
    "title": "Метод получения списка связей камеры и квартиры",
    "method": "get",
    "service": "vc",
    "module": "camera",
    "resource": "room",
    "access": "list",
    "scope": "vc:camera:room:list",
    "description": "Метод доступен для: admin, service, bti, owner, employee",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "get:/vc/api/v1/camera/rtsp_url/external_id/{externalId}",
    "title": "Метод получения RTSP-ссылки по идентификатору камеры в vcfront",
    "method": "get",
    "service": "vc",
    "module": "camera",
    "resource": "rtsp_url",
    "access": "list",
    "scope": "vc:camera:rtsp_url:list",
    "description": "Метод доступен для: admin, service.Метод доступен для: ApiKey",
    "params": [
      "externalId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/vc/api/v1/camera",
    "title": "Метод создания камеры",
    "method": "post",
    "service": "vc",
    "module": "camera",
    "resource": "camera",
    "access": "save",
    "scope": "vc:camera:save",
    "description": "Метод доступен для: admin, service, bti",
    "params": [],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  },
  {
    "name": "post:/vc/api/v1/company/{companyId}/impersonation",
    "title": "Метод генерации имперсонационной ссылки для владельца компании",
    "method": "post",
    "service": "vc",
    "module": "company",
    "resource": "impersonation",
    "access": "save",
    "scope": "vc:company:impersonation:save",
    "description": "Возвращает одноразовую ссылку для имперсонации в сервисе inkey-front.Сценарий работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=1013775798.Метод доступен для: service, bti, admin",
    "params": [
      "companyId"
    ],
    "security": "requires authorization",
    "visibility": "public",
    "specific": "default"
  }
] as const;
